import { Component, OnInit, ElementRef, Renderer2, ChangeDetectorRef, OnDestroy, HostListener } from '@angular/core';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as d3 from 'd3';
import * as cloud from 'd3-cloud';
import { DownloadService } from 'src/app/shared/services/downloads/download.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { extendedRaterFile } from "src/app/shared/services/external-ts-files/extended-rating-mapper";
import { NgIf, NgClass, NgStyle } from '@angular/common';
import { ScoreDropdownMenuComponent } from '../score-dropdown-menu/score-dropdown-menu.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { LtmsErrorComponent } from '../../ltms-error/ltms-error.component';
import { ScoreQuestionBarChartComponent } from '../score-question-bar-chart/score-question-bar-chart.component';
import { ScoreWidgetComponent } from '../score-widget/score-widget.component';
import { ScoreLineChartComponent } from '../score-line-chart/score-line-chart.component';
import { ScoreQuestionTabHorizonatalBarChartComponent } from '../score-question-tab-horizonatal-bar-chart/score-question-tab-horizonatal-bar-chart.component';
import { MSG_CONST } from 'src/app/shared/constants/msg-constants';
import { ScoreComparisonToggleComponent } from '../score-comparison-toggle/score-comparison-toggle.component';
import {
  attachMetricDeviations,
  getComparisonPeriodLabel,
  getDeviationTooltipText,
  getPositiveDeviationValue,
  getShowComparisonFlag,
  isComparisonAvailable,
  setShowComparisonFlag,
  shouldShowDeviation,
} from 'src/app/shared/utils/score-deviation.util';
import { ScoreBarChartComponent } from '../score-bar-chart/score-bar-chart.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';
import {
  buildQuestionTrendBarChartConfig,
  buildStackedSeriesBarChartConfig,
  parseTrendBarCount,
  StackedSeriesDataset,
  TrendBarSegmentCounts,
} from 'src/app/shared/utils/score-question-trend-bar.helper';
@Component({
    selector: 'app-score-question',
    templateUrl: './score-question.component.html',
    styleUrl: './score-question.component.scss',
    imports: [NgIf, NgClass, ScoreDropdownMenuComponent, LtmsLoaderComponent, LtmsErrorComponent, NgStyle, ScoreQuestionBarChartComponent, ScoreWidgetComponent, ScoreLineChartComponent, ScoreQuestionTabHorizonatalBarChartComponent, ScoreComparisonToggleComponent, ScoreBarChartComponent]
})

export class ScoreQuestionComponent implements OnInit, OnDestroy {
  mainTabDiscription: string = 'View individual conversation questions and their responses, including NPS metrics and qualitative feedback, for granular customer insights.';
  overviewDescription: string = 'Shows response count, NPS score, and distribution of promoters, passives, and detractors.';
  trendDescription: string = 'Tracks NPS variations over time, highlighting shifts in customer sentiment.';
  responseTrendDescription: string = 'Shows absolute or percentage response distribution over time for the selected question.';
  wordcloudDescription: string = 'Visualizes frequently mentioned terms from responses, highlighting key themes and sentiments.';

  deletedOptionTooltip = MSG_CONST.DELETED_OPTION_TOOLTIP;

  questionMap: any = {};
  extenderRatingMapper = new extendedRaterFile();

  // Viewtype dropdown
  viewByDropdown: any = {
    config: {
      'width': '280px',
      'tab': 'question'
    },
    selectedOption: 'All questions', 
    options: []
  };
  selectedOption: string = '';
  viewDropdownFieldId: any = '';

  // All question
  isClickToView: boolean = false;

  // Rating type question
  totalResponse: string = '';
  ratingnumber: string = '';
  topPercentage: string = '';
  midPercentage: string = '';
  bottomPercentage: string = '';
  rating: string = '';
  ratingDisplay: string = '';
  topName: string = '';
  midName: string = '';
  bottomName: string = '';
  totalTop: string = '';
  totalMid: string = '';
  totalBottom: string = '';
  barChart: any = {};
  ratingCardLoading: boolean = true;
  isRatingCardError: boolean = false;
  ratingLineChartCardLoading: boolean = true;
  isratingLineChartCardError: boolean = false;
  ratingResponseBarChartLoading: boolean = true;
  isRatingResponseBarChartError: boolean = false;
  totalResponses = 0;

  // default min & max value for all rater/scale rater type
  raterTypeDetails: any = {
    // '0-10': { min: -100, max: 100 },
    '1-10': { min: 0, max: 10 },
    '-5 to 5': { min: -5, max: 5 },
    '-5 to +5': { min: -5, max: 5 },
    '1': { min: -5, max: 5 },
    // '3': { min: -100, max: 100 },
    '4': { min: 0, max: 5 },
    '5': { min: 0, max: 5 },
    '6': { min: 0, max: 10 },
    '7': { min: 0, max: 6 },
    '8': { min: -3, max: 3 },
    '9': { min: 0, max: 4 }
  }

  // Selection based
  selectionBasedCardLoading: boolean = true;
  selectionBasedCardError: boolean = false;

  responseCache: any = {};

  selectionBasedTypeChart = '';
  barChartPlugins: any = {
    yText: 'Responses',
    legend: false
  };
  /** Plugins for Question-tab rating Trend Absolute/Percentage stacked bars */
  ratingTrendBarChartPlugins: any = {
    yText: 'Responses',
    legend: true
  };
  barChartSingleSelect: any = {};

  // Response Absolute–Percentage bar chart (separate card below Trend; rating + multi-select)
  /** Absolute/Percentage for Question trend charts (rating Response Trend, single/multi-select). Persists across date, filter, and View-by. */
  isQuestionTrendChartTypePercentage = false;
  ratingTrendBarChart: any = {};
  ratingTrendBarSegmentsCache: { labels: string[]; segments: TrendBarSegmentCounts[]; headerLabels: any } = {
    labels: [],
    segments: [],
    headerLabels: {},
  };
  singleSelectBarCache: {
    labels: string[];
    datasets: StackedSeriesDataset[];
    safeHtmlLabels: any[];
    values: any[];
    xText: string;
  } = {
    labels: [],
    datasets: [],
    safeHtmlLabels: [],
    values: [],
    xText: '',
  };
  multiSelectLineCache: {
    labels: string[];
    xText: string;
    series: any[];
  } = {
    labels: [],
    xText: '',
    series: [],
  };

  /** Trend card widget — Absolute/Percentage for single-select & multi-select (same chart). */
  scoreWidget(): any {
    const showAbsPct =
      !!this.selectedCardName?.includes('select') &&
      (this.selectionBasedTypeChart === 'singleSelect' || this.selectionBasedTypeChart === 'multiSelect');
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: true,
      isAbsoluteChartShow: showAbsPct,
      isPercenttageChartShow: showAbsPct,
      isPercenttageChartActive: this.isQuestionTrendChartTypePercentage,
    };
  }

  /** Response Trend card widget — Weekly filter, Absolute/Percentage, Download, Fullscreen. */
  responseBarWidget(): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: true,
      isAbsoluteChartShow: true,
      isPercenttageChartShow: true,
      isPercenttageChartActive: this.isQuestionTrendChartTypePercentage,
    };
  }

  lineChartPlugins: any = {
    lineColor: '#2CA02C',
    gradientStartColor: '#2CA02C',
    gradientEndColor: '#2CA02C0F',
    borderWidth: 2,
    pointBorderWidth: 2,
    pointRadius: 6,
    pointBorderColor: '#ffffff',
  };
  lineChartPluginsMultiSelect: any = {
    lineColor: '#ffffff',
    gradientStartColor: '#ffffff',
    gradientEndColor: '#ffffff',
    borderWidth: 2,
    pointBorderWidth: 2,
    pointRadius: 6,
    pointBorderColor: '#ffffff',
    chartType: 'mutliSelect'
  }
  lineChart: any = {};
  lineChartMultiSelect: any = {};
  lineChartTrendEvents: any = {};
  /** Date bucket captured with the Trend card data. Used only by that card's CSV. */
  lineChartCsvTrendEvent: any = {};
  lineChartCsvChart: { labels: any[]; data: any[]; yText: string } = { labels: [], data: [], yText: '' };
  barChartDisplay = '';
  barChartTrendType: any = '';
  /** Date bucket chosen on the Response Trend card. Independent of the Trend card. */
  barChartTrendEvents: any = {};
  /** Date bucket captured with the Response Trend data. Used only by that card's CSV. */
  barChartCsvTrendEvent: any = {};
  responseBarCacheData: any = [];
  responseBarCsvChart: { labels: any[]; data: any[]; yText: string } = { labels: [], data: [], yText: '' };

  // Text based
  textCardLoading: boolean = true;
  isTextCardError: boolean = false;
  wordCloudCardLoading: boolean = true;
  isWordCloudCardError: boolean = false;

  // Selection based question
  toTotalRatedOption: string = '';
  mostSelectedKeyOptions: any = {};
  horizonatlBarChart: any = {};
  horizonatlBarChartDynamicHeight: string = '';

  // Card styling
  selectedCardName: string = '';
  isLoading: boolean = true;
  isError: boolean = false;
  fullScreenComponent: string = '';
  isFullScreen: boolean = false;

  // Download
  lineChartCacheData: any = {};

  // Group Questions
  hover: boolean = false;
  active: boolean = false;
  isQuestionGroupAvialable: boolean = false;
  showComparisonFlag: boolean = false;
  isComparisonAvailable: boolean = true;
  dateType: string = '';
  comparisonPeriodLabel: string = '';
  responsesDeviation: any = null;
  ratingDeviation: any = null;
  previousDetailedRatingCache: any = null;
  lastCrossTabResponse: any = null;
  lastOverviewRatingResponse: any = null;
  lastScoreAccountResponse: { current: any; previous: any } | null = null;

  getPositiveValue = getPositiveDeviationValue;
  shouldShowDeviation = shouldShowDeviation;

  onShowComparisonChange(checked: boolean): void {
    this.showComparisonFlag = checked;
    setShowComparisonFlag(checked);
    if (this.selectedCardName === 'text') {
      if (this.lastScoreAccountResponse) {
        this.prepareOverviewDataForRatingType(
          this.lastScoreAccountResponse.current,
          this.lastScoreAccountResponse.previous
        );
      } else if (!checked) {
        this.clearOverviewDeviations();
      }
    } else if (this.lastOverviewRatingResponse) {
      if (this.active && this.selectedCardName === 'rating') {
        this.prepareOverviewGroupDataForRatingType(this.lastOverviewRatingResponse);
        if (this.lastCrossTabResponse) {
          this.setOverviewDeviationsFromGroupCrossTab(this.lastCrossTabResponse, this.viewDropdownFieldId);
        } else if (checked) {
          this.callGetcrossTabAnalytics();
        } else {
          this.clearOverviewDeviations();
        }
      } else if (!this.active || this.selectedCardName !== 'all-groups') {
        this.prepareOverviewDataForRatingType(this.lastOverviewRatingResponse);
      } else {
        this.clearOverviewDeviations();
      }
    } else if (!checked) {
      this.clearOverviewDeviations();
    }
    if (this.lastCrossTabResponse) {
      if (this.active) {
        const groupDiv = this.el.nativeElement.querySelector('.all-questions-group-table');
        if (groupDiv) {
          this.renderer.setProperty(groupDiv, 'innerHTML', '');
        }
        if (this.selectedCardName === 'all-groups') {
          this.prepareAllQuestionGroupData(this.lastCrossTabResponse);
        }
      } else if (this.selectedCardName === 'all-questions') {
        const parentDiv = this.el.nativeElement.querySelector('.all-questions-table');
        if (parentDiv) {
          this.renderer.setProperty(parentDiv, 'innerHTML', '');
        }
        this.prepareAllQuestionData(this.lastCrossTabResponse);
      }
    }
  }

  private refreshComparisonLabels(): void {
    this.dateType =
      _.get(Helpers, 'datePicker.trendType') ||
      _.get(Helpers, 'datePicker.selectedTrend') ||
      'period';
    this.comparisonPeriodLabel = getComparisonPeriodLabel();
    this.isComparisonAvailable = isComparisonAvailable();
    if (!this.isComparisonAvailable) {
      this.showComparisonFlag = false;
      setShowComparisonFlag(false);
    } else {
      this.showComparisonFlag = getShowComparisonFlag();
    }
  }

  private clearOverviewDeviations(): void {
    this.responsesDeviation = null;
    this.ratingDeviation = null;
  }

  private getNumericMetricsFromRatingBasedData(
    fieldId: any,
    data: any,
    mainRaterType: any,
    scalerRaterType: any,
    isPrimaryRating: boolean,
    cardType: string
  ): { rating: number; responses: number } | null {
    const result = this.getRatingBasedData(fieldId, data, mainRaterType, scalerRaterType, isPrimaryRating, cardType);
    const responses = parseInt(String(result?.totalCount ?? 0).replace(/,/g, ''), 10) || 0;
    if (!responses) {
      return null;
    }
    const ratingVal = result?.rating;
    if (ratingVal === 'N/A' || ratingVal == null || ratingVal === '') {
      return null;
    }
    const rating = typeof ratingVal === 'number' ? ratingVal : parseFloat(String(ratingVal));
    if (isNaN(rating)) {
      return null;
    }
    return { rating, responses };
  }

  private setOverviewDeviationsFromRatingData(
    fieldId: any,
    currentData: any,
    previousData: any,
    mainRaterType: any,
    scalerRaterType: any,
    isPrimaryRating: boolean,
    cardType: string
  ): void {
    this.clearOverviewDeviations();
    if (!this.showComparisonFlag || !currentData) {
      return;
    }
    try {
      const currentMetrics = this.getNumericMetricsFromRatingBasedData(
        fieldId, currentData, mainRaterType, scalerRaterType, isPrimaryRating, cardType
      );
      const previousMetrics = previousData
        ? this.getNumericMetricsFromRatingBasedData(
            fieldId, previousData, mainRaterType, scalerRaterType, isPrimaryRating, cardType
          ) ?? { rating: 0, responses: 0 }
        : { rating: 0, responses: 0 };
      if (!currentMetrics) {
        return;
      }
      const responsesDev = Helpers.getFieldDeviation(currentMetrics.responses, previousMetrics.responses);
      const ratingDev = Helpers.getFieldDeviation(currentMetrics.rating, previousMetrics.rating);
      this.responsesDeviation = shouldShowDeviation(responsesDev) ? responsesDev : null;
      this.ratingDeviation = shouldShowDeviation(ratingDev) ? ratingDev : null;
    } catch (error) {
      console.error('Error computing overview deviations:', error);
    }
  }

  private setSelectionOverviewDeviation(
    currentCount: any,
    previousCount: any,
    mostSelectedCurrentCount?: any,
    mostSelectedPreviousCount?: any
  ): void {
    this.clearOverviewDeviations();
    if (!this.showComparisonFlag) {
      return;
    }
    const current = parseInt(String(currentCount ?? 0).replace(/,/g, ''), 10) || 0;
    const previous = parseInt(String(previousCount ?? 0).replace(/,/g, ''), 10) || 0;
    const deviation = Helpers.getFieldDeviation(current, previous);
    this.responsesDeviation = shouldShowDeviation(deviation) ? deviation : null;
    if (mostSelectedCurrentCount === undefined) {
      return;
    }
    const msCurrent = parseInt(String(mostSelectedCurrentCount ?? 0).replace(/,/g, ''), 10) || 0;
    const msPrevious = parseInt(String(mostSelectedPreviousCount ?? 0).replace(/,/g, ''), 10) || 0;
    const mostSelectedDev = Helpers.getFieldDeviation(msCurrent, msPrevious);
    this.ratingDeviation = shouldShowDeviation(mostSelectedDev) ? mostSelectedDev : null;
  }

  private appendDeviationToRenderedCell(parentElement: HTMLElement, deviation: any): void {
    if (!this.showComparisonFlag || !shouldShowDeviation(deviation)) {
      return;
    }
    const deviationSpan = this.renderer.createElement('span');
    this.renderer.addClass(deviationSpan, 'deviationSeperator');
    this.renderer.addClass(deviationSpan, 'question-table-deviation');
    this.renderer.setAttribute(deviationSpan, 'title', getDeviationTooltipText(deviation, this.comparisonPeriodLabel));
    this.renderer.appendChild(deviationSpan, this.renderer.createText(String(getPositiveDeviationValue(deviation.deviation))));
    const icon = this.renderer.createElement('i');
    this.renderer.addClass(icon, 'fa');
    this.renderer.addClass(icon, `fa-caret-${deviation.arrowType}`);
    this.renderer.appendChild(deviationSpan, icon);
    this.renderer.appendChild(parentElement, deviationSpan);
  }

  private usesAllQuestionsMetricLayout(): boolean {
    return this.showComparisonFlag && this.isComparisonAvailable;
  }

  private isAllQuestionsMetricColumn(parentClassName: string): boolean {
    return parentClassName === 'rating-response-count-span'
      || parentClassName === 'selection-response-count-span'
      || parentClassName === 'rating-rating-span'
      || parentClassName === 'rating-top-span';
  }

  private renderAllQuestionsTableCell(parentSpan: HTMLElement, content: string, parentClassName: string): HTMLElement {
    if (!this.usesAllQuestionsMetricLayout() || !this.isAllQuestionsMetricColumn(parentClassName)) {
      const childSpan = this.renderer.createElement('span');
      this.renderer.appendChild(childSpan, this.renderer.createText(String(content ?? '')));
      this.renderer.appendChild(parentSpan, childSpan);
      return childSpan;
    }
    const wrapper = this.renderer.createElement('span');
    this.renderer.addClass(wrapper, 'metric-cell-value');
    const primary = this.renderer.createElement('span');
    this.renderer.addClass(primary, 'cell-primary-value');
    this.renderer.appendChild(primary, this.renderer.createText(String(content ?? '')));
    this.renderer.appendChild(wrapper, primary);
    this.renderer.appendChild(parentSpan, wrapper);
    return wrapper;
  }

  private appendAllQuestionsTableDeviation(parentElement: HTMLElement, deviation: any, aligned: boolean): void {
    if (!this.showComparisonFlag) {
      return;
    }
    if (!aligned || !this.usesAllQuestionsMetricLayout()) {
      this.appendDeviationToRenderedCell(parentElement, deviation);
      return;
    }
    if (shouldShowDeviation(deviation)) {
      const deviationSpan = this.renderer.createElement('span');
      this.renderer.addClass(deviationSpan, 'deviationSeperator');
      this.renderer.addClass(deviationSpan, 'question-table-deviation');
      this.renderer.addClass(deviationSpan, 'cell-deviation-value');
      this.renderer.setAttribute(deviationSpan, 'title', getDeviationTooltipText(deviation, this.comparisonPeriodLabel));
      this.renderer.appendChild(deviationSpan, this.renderer.createText(String(getPositiveDeviationValue(deviation.deviation))));
      const icon = this.renderer.createElement('i');
      this.renderer.addClass(icon, 'fa');
      this.renderer.addClass(icon, `fa-caret-${deviation.arrowType}`);
      this.renderer.appendChild(deviationSpan, icon);
      this.renderer.appendChild(parentElement, deviationSpan);
      return;
    }
    const placeholder = this.renderer.createElement('span');
    this.renderer.addClass(placeholder, 'cell-deviation-placeholder');
    this.renderer.setAttribute(placeholder, 'aria-hidden', 'true');
    this.renderer.appendChild(parentElement, placeholder);
  }

  private getPreviousDetailedRatingForField(fieldId: any, tableType: string): any {
    if (!this.previousDetailedRatingCache) {
      return null;
    }
    if (tableType === 'selectionBased') {
      return this.previousDetailedRatingCache;
    }
    return _.find(this.previousDetailedRatingCache, { field_id: fieldId })?.detailed_rating_details;
  }

  private getSelectionOptionRawCount(
    fieldId: any,
    data: any,
    option: { value: any; field_id?: any },
    detailedFeedbackItems: any
  ): number {
    if (!data || !option) {
      return 0;
    }
    const isMultiWithGroup = !detailedFeedbackItems?.type?.includes('single');
    const groupMembers = isMultiWithGroup
      ? Helpers.brandDetails.detailed_feedback_items.filter((item: any) => item?.group_id == fieldId)
      : [];

    if (this.selectedCardName === 'all-questions') {
      if (isMultiWithGroup && groupMembers.length > 0 && option.field_id) {
        const result = data.find((item: any) => item.field_id == option.field_id)?.detailed_rating_details;
        return (result && _.isArray(result))
          ? (result.find((r: any) => r.rating == option.value)?.number_of_user_rated || 0)
          : 0;
      }
      if (isMultiWithGroup) {
        const result = data.find((items: any) => items.field_id === fieldId)?.detailed_rating_details;
        return result?.find((r: any) => r.rating == option.value)?.number_of_user_rated || 0;
      }
      const result = data.find((items: any) => items.field_id === fieldId)?.detailed_rating_details;
      if (result?.length > 0) {
        return result.find((r: any) => r.rating == option.value)?.number_of_user_rated || 0;
      }
      return 0;
    }

    if (isMultiWithGroup && groupMembers.length > 0 && option.field_id) {
      let count = 0;
      const obj = data[option.field_id]?.rating_number;
      if (obj && typeof obj === 'object') {
        for (const keys of Object.keys(obj)) {
          if (obj[keys]?.key == option.value) {
            count += obj[keys]?.doc_count || 0;
          }
        }
      }
      return count;
    }
    const ratingNumber = data[fieldId]?.rating_number ?? data[this.viewDropdownFieldId]?.rating_number;
    let count = 0;
    for (const keys in ratingNumber || {}) {
      if (ratingNumber[keys]?.key == option.value) {
        count += ratingNumber[keys]?.doc_count || 0;
      }
    }
    return count;
  }

  private attachSelectionOptionDeviations(
    fieldId: any,
    rowData: any,
    currentData: any,
    detailedFeedbackItems: any
  ): void {
    if (!this.showComparisonFlag || !rowData?.options?.length || typeof Helpers === 'undefined' || !Helpers.getFieldDeviation) {
      return;
    }
    try {
      const previousData = this.getPreviousDetailedRatingForField(fieldId, 'selectionBased');
      rowData.options.forEach((option: any) => {
        const currentCount = this.getSelectionOptionRawCount(fieldId, currentData, option, detailedFeedbackItems);
        const previousCount = previousData
          ? this.getSelectionOptionRawCount(fieldId, previousData, option, detailedFeedbackItems)
          : 0;
        const deviation = Helpers.getFieldDeviation(currentCount, previousCount);
        if (shouldShowDeviation(deviation)) {
          option.deviation = deviation;
        }
      });
    } catch (error) {
      console.error('Error attaching selection option deviations:', error);
    }
  }

  private getBandMetricsFromRatingBasedData(
    fieldId: any,
    data: any,
    mainRaterType: any,
    scalerRaterType: any,
    isPrimaryRating: boolean,
    cardType: string
  ): { top: number; mid: number; bottom: number; hasMid: boolean } | null {
    const result = this.getRatingBasedData(fieldId, data, mainRaterType, scalerRaterType, isPrimaryRating, cardType);
    if (!result) {
      return null;
    }
    const parseCount = (value: any): number => parseInt(String(value ?? 0).replace(/,/g, ''), 10) || 0;
    const midValue = result?.totalMid;
    return {
      top: parseCount(result?.totalTop),
      mid: parseCount(midValue),
      bottom: parseCount(result?.totalBottom),
      hasMid: midValue !== '' && midValue != null,
    };
  }

  private computeAllQuestionRowDeviations(
    fieldId: any,
    tableType: string,
    currentData: any,
    detailedFeedbackItems: any
  ): { responses?: any; rating?: any; top?: any; mid?: any; bottom?: any } {
    try {
      if (typeof Helpers === 'undefined' || !Helpers.getFieldDeviation) {
        return {};
      }
      const previousData = this.getPreviousDetailedRatingForField(fieldId, tableType);
      if (tableType === 'ratingBased') {
        const currentMetrics = this.getNumericMetricsFromRatingBasedData(
          fieldId,
          currentData,
          detailedFeedbackItems?.main_rater_type,
          detailedFeedbackItems?.scale_rater_type,
          detailedFeedbackItems?.is_primary_rating,
          'allQuestion'
        );
        const previousMetrics = this.getNumericMetricsFromRatingBasedData(
          fieldId,
          previousData,
          detailedFeedbackItems?.main_rater_type,
          detailedFeedbackItems?.scale_rater_type,
          detailedFeedbackItems?.is_primary_rating,
          'allQuestion'
        ) ?? { rating: 0, responses: 0 };
        const currentBands = this.getBandMetricsFromRatingBasedData(
          fieldId,
          currentData,
          detailedFeedbackItems?.main_rater_type,
          detailedFeedbackItems?.scale_rater_type,
          detailedFeedbackItems?.is_primary_rating,
          'allQuestion'
        );
        const previousBands = previousData
          ? this.getBandMetricsFromRatingBasedData(
              fieldId,
              previousData,
              detailedFeedbackItems?.main_rater_type,
              detailedFeedbackItems?.scale_rater_type,
              detailedFeedbackItems?.is_primary_rating,
              'allQuestion'
            ) ?? { top: 0, mid: 0, bottom: 0, hasMid: currentBands?.hasMid ?? false }
          : { top: 0, mid: 0, bottom: 0, hasMid: currentBands?.hasMid ?? false };
        if (!currentMetrics || !currentBands) {
          return {};
        }
        const deviations: any = {};
        const responsesDev = Helpers.getFieldDeviation(currentMetrics.responses, previousMetrics.responses);
        const ratingDev = Helpers.getFieldDeviation(currentMetrics.rating, previousMetrics.rating);
        const topDev = Helpers.getFieldDeviation(currentBands.top, previousBands.top);
        const bottomDev = Helpers.getFieldDeviation(currentBands.bottom, previousBands.bottom);
        if (shouldShowDeviation(responsesDev)) {
          deviations.responses = responsesDev;
        }
        if (shouldShowDeviation(ratingDev)) {
          deviations.rating = ratingDev;
        }
        if (shouldShowDeviation(topDev)) {
          deviations.top = topDev;
        }
        if (shouldShowDeviation(bottomDev)) {
          deviations.bottom = bottomDev;
        }
        if (currentBands.hasMid) {
          const midDev = Helpers.getFieldDeviation(currentBands.mid, previousBands.mid);
          if (shouldShowDeviation(midDev)) {
            deviations.mid = midDev;
          }
        }
        return deviations;
      }
      if (tableType === 'selectionBased') {
        const currentResponses = this.getSelectionBasedData(fieldId, currentData)?.totalCount;
        const previousResponses = previousData
          ? this.getSelectionBasedData(fieldId, previousData)?.totalCount
          : 0;
        const current = parseInt(String(currentResponses ?? 0).replace(/,/g, ''), 10) || 0;
        const previous = parseInt(String(previousResponses ?? 0).replace(/,/g, ''), 10) || 0;
        const responseDev = Helpers.getFieldDeviation(current, previous);
        return shouldShowDeviation(responseDev) ? { responses: responseDev } : {};
      }
    } catch (error) {
      console.error('Error computing question row deviations:', error);
    }
    return {};
  }

  onOptionChange(event: any, type: string): void {
    this.isLoading = true;
    this.isError = false;
    this.ratingCardLoading = true;
    this.selectionBasedCardLoading = true;
    this.textCardLoading = true;
    this.wordCloudCardLoading = true;
    if (type === 'viewByDropdown') {
      this.selectedCardName = event?.type;
      this.viewDropdownFieldId = event?.field_id;
      this.isLoading = true;
      this.selectedOption = event?.type === 'all-questions' || event?.type === 'all-groups' ? '' : event?.name;
      if(this.active) {
        this.callGroupApi();
      } else {
        this.callApi();
      }
      if(this.selectedOption) {
        this.refreshTrendChartIfNeeded();
      }
    }
  }

  onTrendChange(event: any, cardName?: string): void {
    if (cardName === 'barChart') {
      this.barChartTrendEvents = event || {};
      this.barChartDisplay = event?.display || '';
      this.barChartTrendType = event?.trend_type;
      this.queueResponseBarLoad();
      return;
    }
    this.lineChartTrendEvents = event;
    this.queueLineChartLoad();
  }

  /** Question-tab only: Absolute vs Percentage for Response Trend card (rating, below Trend). */
  onResponseBarChartTypeChange(isPercentage: boolean): void {
    this.isQuestionTrendChartTypePercentage = !!isPercentage;
    this.applyRatingTrendBarChartFromCache();
  }

  /** Single-select / multi-select Trend: Absolute vs Percentage in the same chart. */
  onSelectionTrendChartTypeChange(isPercentage: boolean): void {
    this.isQuestionTrendChartTypePercentage = !!isPercentage;
    if (this.selectionBasedTypeChart === 'singleSelect') {
      this.applySingleSelectBarChartFromCache();
      return;
    }
    if (this.selectionBasedTypeChart === 'multiSelect') {
      this.applyMultiSelectLineChartFromCache();
    }
  }

  onFullScreen(event: any, cardName: string) {
    this.isFullScreen = !this.isFullScreen;
    this.fullScreenComponent = this.isFullScreen ? cardName : '';
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    this.isFullScreen = false;
    this.fullScreenComponent = '';
  }

  onOverlayClick(): void {
    this.isFullScreen = false;
    this.fullScreenComponent = '';
  }

  onDownload(cardName?: string): void {
    if (cardName === 'barChart') {
      this.downloadResponseBarCsv();
      return;
    }
    if(this.lineChartCacheData.length === 0 || !this.lineChartCacheData || Object.keys(this.lineChartCacheData).length === 0) {
      this.toastService.showPopup('WARN', 'No data is available for download with the selected filters.', '', 5000);
      return;
    }
    const trendEvent = cardName === 'lineChart' ? this.lineChartCsvTrendEvent : undefined;
    let tableInfo = this.prepareTableInfoToCSV(trendEvent);
    let data: any = [];
    const questionType = this.getSelectedTrendQuestion();
    if(questionType?.type == 'rating') {
      data = cardName === 'lineChart' && this.lineChartCsvChart.labels?.length
        ? this.prepareChartDataIntoCSVForPrimaryQuestion({
            cacheData: this.lineChartCacheData,
            labels: this.lineChartCsvChart.labels,
            data: this.lineChartCsvChart.data,
            yText: this.lineChartCsvChart.yText,
          })
        : this.prepareChartDataIntoCSVForPrimaryQuestion();
    } else if(questionType?.type == 'single-select') {
      data = this.prepareChartDataIntoCSVForMultiSelect({
        labels: this.singleSelectBarCache.labels,
        dataset: this.singleSelectBarCache.datasets.map((item, index) => ({
          ...item,
          label: this.singleSelectBarCache.safeHtmlLabels[index],
        })),
      });
    } else if(questionType?.type == 'multi-select') {
      data = this.prepareChartDataIntoCSVForMultiSelect({
        labels: this.multiSelectLineCache.labels,
        data: this.multiSelectLineCache.series,
      });
    }
    let combinedCSV = tableInfo + '\n\n' + data;
    this.sendReportForDownload(combinedCSV, trendEvent);
  }

  /** Response Trend CSV uses that card's date bucket and response cache. */
  private downloadResponseBarCsv(): void {
    const cache = this.responseBarCacheData;
    if (!cache || cache.length === 0 || Object.keys(cache).length === 0) {
      this.toastService.showPopup('WARN', 'No data is available for download with the selected filters.', '', 5000);
      return;
    }
    const trendEvent = this.barChartCsvTrendEvent;
    const tableInfo = this.prepareTableInfoToCSV(trendEvent);
    const data = this.prepareChartDataIntoCSVForPrimaryQuestion({
      cacheData: cache,
      labels: this.responseBarCsvChart.labels,
      data: this.responseBarCsvChart.data,
      yText: this.responseBarCsvChart.yText,
    });
    this.sendReportForDownload(tableInfo + '\n\n' + data, trendEvent);
  }

  questionGroupClick(): void {
    this.active = !this.active;
    this.isLoading = true;
    this.selectedCardName = '';
    if(this.active) {
      this.viewByDropdown.selectedOption = 'All groups';
      this.selectedOption = '';
      this.prepareQuestionGroup();
      this.callGroupApi();
    } else {
      this.viewByDropdown.selectedOption = 'All questions';
      this.selectedOption = '';
      this.prepareViewByDropdown();
      this.callApi();
    }
  }

  private destroy$ = new Subject<void>();
  private lineChartTrigger$ = new Subject<void>();
  private responseBarTrigger$ = new Subject<void>();
  private lineChartSubscription?: Subscription;
  private responseBarSubscription?: Subscription;
  private lineChartRequestId = 0;
  private responseBarRequestId = 0;
  
  constructor(
    private responseAnalyticsService: ResponseAnalyticsService, 
    private helpersService: HelpersService,
    private el: ElementRef, 
    private renderer: Renderer2,
    private changeDetector: ChangeDetectorRef,
    private downloadService: DownloadService,
    private toastService: ToastService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.lineChartTrigger$.pipe(debounceTime(100), takeUntil(this.destroy$)).subscribe(() => {
      this.callTrendDataRatingSummary();
    });
    this.responseBarTrigger$.pipe(debounceTime(100), takeUntil(this.destroy$)).subscribe(() => {
      this.callApiForResponseBar();
    });
    this.refreshComparisonLabels();
    this.execute();
    this.helpersService.appState.pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response && response.pending == false) {
        this.refreshComparisonLabels();
        this.isLoading = true;
        if(this.active) {
          this.callGroupApi();
        } else {
          this.callApi();
        }
        this.refreshTrendChartIfNeeded();
      }
    })
  }

  private execute(): void {
    this.checkQuestionGroup();
    this.prepareViewByDropdown();
  }

  private checkQuestionGroup(): void {
    let questionGroupAvaible = false;
    const questionGroup: any = _.get(Helpers, 'brandDetails.dynamic_properties.question_group', null);
    const questionGroupIds: any = [];
    
    if (questionGroup && Array.isArray(questionGroup)) {
      _.forEach(questionGroup, item => {
        if (item?.id && item?.name) {
          questionGroupIds.push({id: item.id, name: item.name});
        }
      });
    }

    if(questionGroupIds && questionGroupIds.length > 0) {
      questionGroupIds.forEach(item => {
        const detailedFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
        if(detailedFeedbackItems && _.size(detailedFeedbackItems) > 0) {
          const detailedFeedbackItemsArray = _.filter(detailedFeedbackItems, obj => 
            obj?.dynamic_properties?.question_group && 
            _.some(obj.dynamic_properties.question_group, { id: item?.id })
          );
          if(detailedFeedbackItemsArray && detailedFeedbackItemsArray.length) {
            questionGroupAvaible = true;
          }
        }
      });
    }
    
    if(questionGroup && questionGroup.length > 0 && questionGroupAvaible) {
      this.isQuestionGroupAvialable = true;
    } else {
      this.isQuestionGroupAvialable = false;
    }
  }

  private prepareQuestionGroup(): void {
    this.viewByDropdown.options = [];
    const questionGroup: any = _.get(Helpers, 'brandDetails.dynamic_properties.question_group', null);
    if(questionGroup && questionGroup.length > 0) {
      this.viewByDropdown.options.push({name: 'All groups', field_id: 'all-groups', type: 'all-groups'});
      questionGroup.forEach(items => {
        const detailedFeedbackItems = Helpers?.brandDetails?.detailed_feedback_items || [];
        if(detailedFeedbackItems && detailedFeedbackItems.length > 0) {
          const result = detailedFeedbackItems.find(item =>
            item.dynamic_properties?.question_group?.some(group => group.id === items?.id)
          );
          if(_.size(result) > 0) {
            this.viewByDropdown.options.push({name: items?.name, field_id: items?.id, type: result?.type});
          }
        }
      })
    }
    this.selectedCardName = 'all-groups';
  }

  private prepareViewByDropdown(): void {
    try {
      const detailedFeedbackItems = Helpers?.brandDetails?.detailed_feedback_items || [];

      // Initialize an empty object to store questions keyed by field_id
      this.questionMap = {}
      // Loop through each feedback item in the detailedFeedbackItems array
      for (const item of detailedFeedbackItems) {
        // Check if the item has a 'field_id' property
        if ('field_id' in item) {
          // Use the field_id as the key and store the item in questionMap
          this.questionMap[item.field_id] = item;
        }
      }
      const mainRaterType = _.get(Helpers, 'brandDetails.main_rater_type') || _.get(Helpers, 'brandDetails.scaler_rater_type') || null;
      if (detailedFeedbackItems.length > 0) {
        const isValidQuestion = (response: any) =>
          (response?.type === 'rating' || response?.type === 'single-select' || response?.type === 'multi-select' || (response?.type === 'text' && !response?.is_user_info)) &&
          !(response?.type === 'single-select' && response?.group_id) &&
          response?.conversation_type === 'question' &&
          (response?.is_displayed_on_dashboard || response?.is_display_on_dashboard);
          const filterItems = _.filter(detailedFeedbackItems, (response: any) => isValidQuestion(response) && !(response?.is_deleted));
          const primaryRatingItems = _.filter(filterItems, (response: any) => response?.is_primary_rating).map((response: any) => ({
            name: response?.question, field_id: response?.field_id, field_type: 'question', is_primary_rating: true, type: response?.type, isPrefix: true
          }));
          const commentsItems = _.filter(filterItems, (response: any) => response?.is_primary_comment).map((response: any) => ({
            name: response?.question, field_id: response?.field_id, field_type: 'question', is_primary_comment: true, question_ids: ['comments'], type: response?.type, isPrefix: true
          }));
          const otherItems = _.filter(filterItems, (response: any) => !response?.is_primary_rating && !response?.is_primary_comment).map((response: any) => ({
            name: response?.question, field_id: response?.field_id, field_type: 'question', type: response?.type, question_ids: response?.type === 'text' ? [response?.field_id] : null, isPrefix: true
          }));
        const compareDropdownAfterSorting = _.concat(
          [{ name: 'All questions', field_id: 'all-questions', type: 'all-questions' }],
          primaryRatingItems,
          commentsItems,
          otherItems
        );
        const filteredData = compareDropdownAfterSorting.filter(item => !(!mainRaterType && item.type === "text"));
        this.selectedCardName = 'all-questions';
        this.viewByDropdown.options = filteredData;
      }
    } catch (error) {
      console.error('Error preparing dropdown options:', error);
    }
  }

  private callApi(): void {
    this.barChart = {};
    this.ratingTrendBarChart = {};
    this.selectionBasedTypeChart = '';
    this.ratingTrendBarSegmentsCache = { labels: [], segments: [], headerLabels: {} };
    this.responseBarCacheData = [];
    this.responseBarCsvChart = { labels: [], data: [], yText: '' };
    this.barChartCsvTrendEvent = {};
    this.singleSelectBarCache = { labels: [], datasets: [], safeHtmlLabels: [], values: [], xText: '' };
    this.multiSelectLineCache = { labels: [], xText: '', series: [] };
    this.ratingCardLoading = true;
    this.selectionBasedCardLoading = true;
    this.textCardLoading = true;
    this.wordCloudCardLoading = true;
    if(this.selectedCardName === 'all-questions') {
      this.callGetcrossTabAnalytics();
    } else if(this.selectedCardName === 'rating') {
      this.isLoading = false;
      this.callGetOverallRating();
    } else if(this.selectedCardName === 'text') {
      this.isLoading = false;
      this.callGetScoreAccount();
      this.callApiForWordCloud();
    } else {
      this.isLoading = false;
      this.callGetOverallRating();
    }
  }

  private callGroupApi(): void {
    this.barChart = {};
    this.ratingTrendBarChart = {};
    this.selectionBasedTypeChart = '';
    this.ratingTrendBarSegmentsCache = { labels: [], segments: [], headerLabels: {} };
    this.responseBarCacheData = [];
    this.responseBarCsvChart = { labels: [], data: [], yText: '' };
    this.barChartCsvTrendEvent = {};
    this.singleSelectBarCache = { labels: [], datasets: [], safeHtmlLabels: [], values: [], xText: '' };
    this.multiSelectLineCache = { labels: [], xText: '', series: [] };
    this.ratingCardLoading = true;
    this.selectionBasedCardLoading = true;
    this.textCardLoading = true;
    this.wordCloudCardLoading = true;

    if(this.selectedCardName === 'all-groups') {
      this.callGetcrossTabAnalytics();
    } else if(this.selectedCardName === 'rating') {
      this.isLoading = false;
      this.callGetOverallRating();
      this.callGetcrossTabAnalytics();
    } else if(this.selectedCardName === 'text') {
      this.isLoading = false;
      this.isError = false;
      this.textCardLoading = false;
      this.isTextCardError = true;
      this.wordCloudCardLoading = false;
      this.isWordCloudCardError = true;
    }
  }

  private callGetcrossTabAnalytics(): void {
    let payload: any = {
      manager_type: 2,
      brand_id: _.get(Helpers, 'brandDetails._id', null),
      main_rater_type: _.get(Helpers, 'brandDetails.main_rater_type', 2),
      shop_id_list: [],
      trend_type: _.get(Helpers, 'datePicker.selectedTrend', null),
      from: _.get(Helpers, 'datePicker.startDate', null),
      to: _.get(Helpers, 'datePicker.endDate', null),
      is_custom_date_range_selected: _.get(Helpers, 'datePicker.isCustomDateRangeSelected', false),
      universal_filter: _.get(Helpers, 'universalFilter', null),
      hierarchy_stack: _.get(Helpers, 'hierarchyStack', null),
      group_alias_key: this.getGroupAliasKey()
    };
    payload = _.omitBy(payload, _.isNil);
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getcrossTabAnalytics(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response?.message === 'Success') {
        this.lastCrossTabResponse = response;
        this.previousDetailedRatingCache = _.get(
          _.find(_.get(response, 'data.response', []), { key: 'previous' }),
          'detailed_rating',
          null
        );
        if (this.active) {
          if (this.selectedCardName === 'all-groups') {
            this.prepareAllQuestionGroupData(response);
          } else if (this.selectedCardName === 'rating') {
            this.setOverviewDeviationsFromGroupCrossTab(response, this.viewDropdownFieldId);
          }
        } else if (this.active === false) {
          this.prepareAllQuestionData(response);
        }
      } else {
        this.isLoading = false;
        this.isError = true;
      }
    })
  }

  private prepareAllQuestionData(response: any): void {
    let isTableEmpty: boolean = true;
    let detailedRating = _.get(_.find(_.get(response, 'data.response', []), { key: 'current' }), 'detailed_rating', null);
    this.isLoading = false;
    this.isError = false;
    this.changeDetector.detectChanges();
    const parentDiv = this.el.nativeElement.querySelector('.all-questions-table');
    if (parentDiv) {
      this.renderer.setProperty(parentDiv, 'innerHTML', '');
    }
    if (_.isArray(detailedRating) && !_.isEmpty(detailedRating)) {
      _.forEach(this.viewByDropdown?.options, (item) => {
        try {
        if (_.get(item, 'type') === 'rating') {
          isTableEmpty = false;
          const result = _.find(detailedRating, { field_id: item?.field_id })?.detailed_rating_details;
          if (result && !_.isEmpty(result)) {
            this.prepareTableDataForAllQuestions(item?.field_id, result, 'ratingBased');
          }
        } else if(_.get(item, 'type') === 'single-select' || _.get(item, 'type') === 'multi-select') {
          isTableEmpty = false;
          this.prepareTableDataForAllQuestions(item?.field_id, detailedRating, 'selectionBased');
        } else if(_.get(item, 'type') === 'text') {
          isTableEmpty = false;
          const result = _.find(detailedRating, { field_id: item?.field_id })?.detailed_rating_details;
          if (result && !_.isEmpty(result)) {
            this.prepareDataForTextType(item?.field_id, result);
          }
        } else {
          if(isTableEmpty) {
            this.isLoading = false;
            this.isError = true;
          }
        }
        } catch (error) {
          console.error('Error preparing question table row:', item?.field_id, error);
        }
      });
    } else {
      this.isLoading = false;
      this.isError = true;
    }
  }

  private buildGroupHeaderFromGroupId(groupId: string): any | null {
    const detailedFeedbackItems: any[] = _.get(Helpers, 'brandDetails.detailed_feedback_items', []) || [];
    const detailedFeedbackItemsArray = _.filter(
      detailedFeedbackItems,
      (obj) => obj.dynamic_properties && _.some(obj.dynamic_properties.question_group, { id: groupId })
    );
    if (!detailedFeedbackItemsArray.length) {
      return null;
    }
    const header: any = {
      mainTableName: _.find(_.get(Helpers, 'brandDetails.dynamic_properties.question_group', []), { id: groupId })?.name,
      type: detailedFeedbackItemsArray[0]?.type,
      main_rater_type: detailedFeedbackItemsArray[0]?.main_rater_type,
      scale_rater_type: detailedFeedbackItemsArray[0]?.scale_rater_type,
      is_primary_rating: detailedFeedbackItemsArray[0]?.is_primary_rating,
      prop: detailedFeedbackItemsArray[0]?.prop,
      subTableName: []
    };
    _.forEach(detailedFeedbackItemsArray, (detailedFeedbackItem) => {
      header.subTableName.push({
        text: detailedFeedbackItem?.text || detailedFeedbackItem?.question,
        field_id: detailedFeedbackItem?.field_id,
        prop: detailedFeedbackItem?.prop
      });
    });
    return header;
  }

  private setOverviewDeviationsFromGroupCrossTab(response: any, groupId: string): void {
    this.clearOverviewDeviations();
    if (!this.showComparisonFlag || !groupId || !response) {
      return;
    }
    const header = this.buildGroupHeaderFromGroupId(groupId);
    if (!header || header.type !== 'rating') {
      return;
    }
    const deviations = this.computeGroupRowDeviations(header, response);
    this.responsesDeviation = shouldShowDeviation(deviations?.responses) ? deviations.responses : null;
    this.ratingDeviation = shouldShowDeviation(deviations?.rating) ? deviations.rating : null;
  }

  private prepareAllQuestionGroupData(response: any): void {
    this.totalResponses = 0;
    this.isLoading = false;
    this.isError = false;
    this.changeDetector.detectChanges();
    const groupDiv = this.el.nativeElement.querySelector('.all-questions-group-table');
    if (groupDiv) {
      this.renderer.setProperty(groupDiv, 'innerHTML', '');
    }
    const questionGroup: any = _.get(Helpers, 'brandDetails.dynamic_properties.question_group', null);
    const questionGroupIds: any = [];
    _.forEach(questionGroup, item => {
      questionGroupIds.push({id: item?.id, name: item?.name});
    })
    questionGroupIds.forEach(item => {
      const detailedFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
      if(_.size(detailedFeedbackItems) > 0) {
        const detailedFeedbackItemsArray = _.filter(detailedFeedbackItems, obj => 
          obj.dynamic_properties && _.some(obj.dynamic_properties.question_group, { id: item?.id })
        );
        let header: any = {
          mainTableName: item?.name,
          type: detailedFeedbackItemsArray[0]?.type,
          main_rater_type: detailedFeedbackItemsArray[0]?.main_rater_type,
          scale_rater_type: detailedFeedbackItemsArray[0]?.scale_rater_type,
          is_primary_rating: detailedFeedbackItemsArray[0]?.is_primary_rating,
          prop: detailedFeedbackItemsArray[0]?.prop,
          subTableName: []
        };
        _.forEach(detailedFeedbackItemsArray, detailedFeedbackItem => {
          header.subTableName.push({
            text: detailedFeedbackItem?.text || detailedFeedbackItem?.question,
            field_id: detailedFeedbackItem?.field_id,
            prop: detailedFeedbackItem?.prop
          })
        })
        this.prepareAllGroupQuestionsData(header, response);
      }
    })
  }

  private prepareAllGroupQuestionsData(header: any, response: any): void {
    this.responseCache = response;
    if(header?.type === 'rating') {
      const calculatedData = this.prepareDataForAllGroup(header, response);
      this.totalResponses = this.totalResponses + calculatedData?.rawTotal;
      let headerLabels = this.getHeaderLabels(
        header?.main_rater_type,
        header?.scale_rater_type,
        header?.is_primary_rating,
      );
      let mainRow = {
        question: header?.mainTableName,
        totalCount: calculatedData?.totalResponse,
        totalTop: calculatedData?.totalTop,
        totalMid: calculatedData?.totalMid,
        totalBottom: calculatedData?.totalBottom,
        rating: calculatedData?.rating,
        seprateRating: calculatedData?.seprateRating,
        deviations: this.computeGroupRowDeviations(header, response)
      };
      this.prepareAllGroupTable(headerLabels, header?.type, mainRow);
    } else if(header?.type === 'text') {
      const detailedFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
      const detailedFeedbackItem = _.find(detailedFeedbackItems, { is_primary_rating: true });
      let headerLabels = this.getHeaderLabels(
        detailedFeedbackItem?.main_rater_type,
        detailedFeedbackItem?.scale_rater_type,
        detailedFeedbackItem?.is_primary_rating
      );
      let mainRow = {
        question: header?.mainTableName,
        totalCount: 0,
        rating: 'N/A',
        totalTop: 'N/A',
        totalMid: 'N/A',
        totalBottom: 'N/A',
        distribution: 'N/A',
      }
      this.prepareAllGroupTable(headerLabels, header?.type, mainRow);
    }
    if(this.totalResponses == 0) {
      this.isError = true;
    }
  }

  private prepareAllGroupTable(headerLabels, type, mainRow): void {
    this.isLoading = false;
    this.isError = false;
    let scoreDisplayName: string = _.get(Helpers, 'brandDetails.label_configs.Score.value', 'Score');
    if(!scoreDisplayName) {
        scoreDisplayName = 'Score';
    }
    this.changeDetector.detectChanges();
    const parentDiv = this.el.nativeElement.querySelector('.all-questions-group-table');
    const tableContainer = this.renderer.createElement('div');
    this.renderer.addClass(tableContainer, 'rating-table-container');
    this.renderer.setAttribute(tableContainer, 'id', mainRow?.question);
    // ======== Table Header ========
    const tableHeader = this.renderer.createElement('div');
    this.renderer.addClass(tableHeader, 'rating-table-header');
    const headerCells = [
      { content: 'Question group', className: '' },
      { content: 'Response Count', className: 'rating-response-count-span' },
      { content: scoreDisplayName, className: 'rating-rating-span' },
    ];
    headerCells.push(
      { content: headerLabels?.top, className: 'rating-top-span' },
      { content: headerLabels?.mid, className: 'rating-top-span' },
      { content: headerLabels?.bottom, className: 'rating-top-span' },
      { content: 'Distribution', className: '',  }
    )
    headerCells.forEach(cell => {
      const parentSpan = this.renderer.createElement('span');
      if(cell.className) {
        this.renderer.addClass(parentSpan, cell.className);
        const childSpan = this.renderer.createElement('span');
        const childSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(childSpan, childSpanText);
        this.renderer.appendChild(parentSpan, childSpan);
      } else {
        if(cell.content === 'Question group') {
          const box = this.renderer.createElement('span');
          this.renderer.addClass(box, 'questionGroupBox');
          if(type === 'rating') {
            const image = this.renderer.createElement('img');
            this.renderer.addClass(image, 'questionGroupIcon');
            this.renderer.setAttribute(image, 'src', 'assets/images/chevron-right.svg');
            this.renderer.appendChild(box, image);
          } else {
            this.renderer.setStyle(box, 'cursor', 'default');
          }
          this.renderer.appendChild(parentSpan, box);
          if(type === 'rating') {
            this.renderer.listen(box, 'click', () => {
              if (box.classList.contains('questionGroupBoxActive')) {
                this.createExpandedTable('remove', mainRow?.question);
                this.renderer.removeClass(box, 'questionGroupBoxActive');
              } else {
                this.createExpandedTable('create', mainRow?.question);
                this.renderer.addClass(box, 'questionGroupBoxActive');
              }
            });
          }
        }
        const parentSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(parentSpan, parentSpanText);
      }
      this.renderer.appendChild(tableHeader, parentSpan);
    })
    this.renderer.appendChild(tableContainer, tableHeader);
    this.renderer.appendChild(parentDiv, tableContainer);

    // ======== Table Row ========
    const tableRow = this.renderer.createElement('div');
    this.renderer.addClass(tableRow, 'rating-table-row');
    const rowCells: any = [
      { content: mainRow.question, parentClassName: '', childClassName: '' },
      { content: mainRow.totalCount, parentClassName: 'rating-response-count-span', childClassName: '', deviation: mainRow.deviations?.responses },
      { content: mainRow.rating, parentClassName: 'rating-rating-span', childClassName: '', deviation: mainRow.deviations?.rating },
    ];
    rowCells.push(
      { content: mainRow.totalTop, parentClassName: 'rating-top-span', childClassName: '', deviation: mainRow.deviations?.top },
      { content: mainRow.totalMid, parentClassName: 'rating-top-span', childClassName: '', deviation: mainRow.deviations?.mid },
      { content: mainRow.totalBottom, parentClassName: 'rating-top-span', childClassName: '', deviation: mainRow.deviations?.bottom }
    );
    if (mainRow?.distribution === 'N/A') {
      rowCells.push({content: '', parentClassName: '', childClassName: ''});
    } else {
      rowCells.push({content: 'Click to view', parentClassName: '', childClassName: 'rating-distribution-button', distribution: mainRow.seprateRating});
    }
    rowCells.forEach((cell, index) => {
      const parentSpan = this.renderer.createElement('span');
      let deviationTarget: HTMLElement = parentSpan;
      if(cell.parentClassName && cell.childClassName) {
        this.renderer.addClass(parentSpan, cell.parentClassName);
        cell.content.forEach(item => {
          const childSpan = this.renderer.createElement('span');
          this.renderer.addClass(childSpan, cell.childClassName);
          const labelSpan = this.renderer.createElement('span');
          const labelText = this.renderer.createText(item.label);
          this.renderer.appendChild(labelSpan, labelText);
          this.renderer.appendChild(childSpan, labelSpan);
          const countSpan = this.renderer.createElement('span');
          const countText = this.renderer.createText(item.response);
          this.renderer.appendChild(countSpan, countText);
          this.renderer.appendChild(childSpan, countSpan);
          this.renderer.appendChild(parentSpan, childSpan);
        });
      } else if(cell.childClassName) {
        const uniqueId = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
        const childSpan = this.renderer.createElement('span');
        this.renderer.addClass(childSpan, cell.childClassName);
        const childSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(childSpan, childSpanText);
        this.renderer.appendChild(parentSpan, childSpan);
        this.renderer.setAttribute(childSpan, 'fieldId', String(uniqueId)+index);
        this.renderer.listen(childSpan, 'click', () => {
          this.showDistributionDropdown(cell, String(uniqueId)+index, 'all-questions-group-table');
        });
      } else if(cell.parentClassName) {
        this.renderer.addClass(parentSpan, cell.parentClassName);
        const childSpan = this.renderer.createElement('span');
        this.renderer.appendChild(childSpan, this.renderer.createText(cell.content));
        this.renderer.appendChild(parentSpan, childSpan);
        deviationTarget = childSpan;
      } else {
        const parentSpanText = this.renderer.createText(cell.content);
        if(index === 0) {
          const box = this.renderer.createElement('span');
          this.renderer.addClass(box, 'questionGroupBox');
          this.renderer.setStyle(box, 'cursor', 'default');
          this.renderer.appendChild(parentSpan, box);
        }
        this.renderer.appendChild(parentSpan, parentSpanText);
      }
      this.appendDeviationToRenderedCell(deviationTarget, cell.deviation);
      this.renderer.appendChild(tableRow, parentSpan);
    })
    this.renderer.appendChild(tableContainer, tableRow);
    this.renderer.appendChild(parentDiv, tableContainer);
  }

  private createExpandedTable(action, fieldId): void {
    const parentDiv = document.getElementById(fieldId);
    if (parentDiv && action === 'remove') {
      const children = Array.from(parentDiv.children);
      if (children.length > 2) {
        for (let i = children.length - 1; i >= 2; i--) {
          parentDiv.removeChild(children[i]);
        }
      }
      return;
    }
    let scoreDisplayName: string = _.get(Helpers, 'brandDetails.label_configs.Score.value', 'Score');
    if(!scoreDisplayName) {
        scoreDisplayName = 'Score';
    }
    const detailedFeedbackItems = Helpers?.brandDetails?.detailed_feedback_items || [];
    const detailedFeedbackItem = detailedFeedbackItems.find(item =>
      item.dynamic_properties?.question_group?.some(group => group.name === fieldId)
    );
    let headerLabels = this.getHeaderLabels(
      detailedFeedbackItem?.main_rater_type,
      detailedFeedbackItem?.scale_rater_type,
      detailedFeedbackItem?.is_primary_rating
    );
    if (parentDiv) {
      const tableHeader = this.renderer.createElement('div');
      this.renderer.addClass(tableHeader, 'rating-table-header');
      const headerCells = [
        { content: 'Question', className: '' },
        { content: 'Response Count', className: 'rating-response-count-span' },
        { content: scoreDisplayName, className: 'rating-rating-span' },
      ];
      headerCells.push(
        { content: headerLabels?.top, className: 'rating-top-span' },
        { content: headerLabels?.mid, className: 'rating-top-span' },
        { content: headerLabels?.bottom, className: 'rating-top-span' },
        { content: 'Distribution', className: '',  }
      )
      headerCells.forEach(cell => {
        const parentSpan = this.renderer.createElement('span');
        if(cell.className) {
          this.renderer.addClass(parentSpan, cell.className);
          const childSpan = this.renderer.createElement('span');
          const childSpanText = this.renderer.createText(cell.content);
          this.renderer.appendChild(childSpan, childSpanText);
          this.renderer.appendChild(parentSpan, childSpan);
        } else {
          if(cell.content === 'Question') {
            const box = this.renderer.createElement('span');
            this.renderer.addClass(box, 'questionGroupBox');
            this.renderer.setStyle(box, 'cursor', 'default');
            this.renderer.appendChild(parentSpan, box);
          }
          const parentSpanText = this.renderer.createText(cell.content);
          this.renderer.appendChild(parentSpan, parentSpanText);
        }
        this.renderer.appendChild(tableHeader, parentSpan);
      })
      this.renderer.appendChild(parentDiv, tableHeader);
      const detailedFeedbackItemsArray = _.filter(detailedFeedbackItems, obj => 
        obj.dynamic_properties && _.some(obj.dynamic_properties.question_group, { name: fieldId})
      );
      detailedFeedbackItemsArray.forEach((item, index) => {
        const currentDetailedRating = _.get(_.find(this.responseCache.data.response, { key: 'current' }), 'detailed_rating', []);
        const category = this.responseAnalyticsService.getRatingBandsByRaterType(item?.scale_rater_type);
        let totalResponse = 0;
        let sumOfRating = 0;
        let totalTop = 0;
        let totalMid = 0;
        let totalBottom = 0;
        let rating: any = 0;
        let seprateRating: any = [];
        for(let key in item?.prop) {
          seprateRating.push({...item?.prop[key], count: 0, percentage: '0%'});
        }
        const result = _.find(currentDetailedRating, { field_id: item?.field_id });
        totalResponse = totalResponse + (result?.number_of_user_rated || 0);
        sumOfRating = sumOfRating + (result?.sum || 0);
        if(result?.detailed_rating_details && result?.detailed_rating_details.length > 0) {
          result.detailed_rating_details.forEach(detailedRatingDetail => {
            const ratings = detailedRatingDetail.rating || 0;
            const numberOfUsersRated = detailedRatingDetail?.number_of_user_rated || 0;
            if (category.bottom.includes(ratings)) {
              totalBottom += numberOfUsersRated;
            } else if (category?.mid && category?.mid.includes(ratings)) {
              totalMid += numberOfUsersRated;
            } else if (category.top.includes(ratings)) {
              totalTop += numberOfUsersRated;
            }
          })
        }
        if(item?.scale_rater_type == '0-10' || item?.scale_rater_type == '1-5') {
          rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
          if (rating !== 'N/A') {
            if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
              rating = Math.floor(rating);
            } else if (rating > 0 && rating % 1 === 0.5) {
              rating = Math.ceil(rating);
            } else {
              rating = Math.round(rating);
            }
          }
        } else {
          rating = totalResponse > 0 ? (sumOfRating / totalResponse).toFixed(2) : 'N/A';
        }
        const results = _.find(currentDetailedRating, { field_id: item?.field_id });
        if(result?.detailed_rating_details && results?.detailed_rating_details.length > 0) {
          results.detailed_rating_details.forEach(detailedRatingDetail => {
            let ratingObj = seprateRating.find(items => items.value == detailedRatingDetail.rating);
            ratingObj.count = ratingObj.count + detailedRatingDetail?.number_of_user_rated || 0;
            ratingObj.percentage = totalResponse > 0 ? (((ratingObj.count || 0) / totalResponse) * 100).toFixed(1) + '%' : '0%';
          })
        }
        const currentDetails = result?.detailed_rating_details;
        const rowDeviations = this.computeAllQuestionRowDeviations(
          item?.field_id,
          'ratingBased',
          currentDetails,
          item
        );
        let mainRow = {
          question: item?.text || item?.question || '',
          totalCount: this.responseAnalyticsService.formatNumber(totalResponse),
          totalTop: this.responseAnalyticsService.formatNumber(totalTop),
          totalMid: item?.scale_rater_type == '-5 to +5' || item?.scale_rater_type == '-5 to 5' || item?.scale_rater_type == '1' || (item?.scale_rater_type == '8' && !item?.is_primary_rating) ? '' : this.responseAnalyticsService.formatNumber(totalMid),
          totalBottom: this.responseAnalyticsService.formatNumber(totalBottom),
          rating: rating,
          seprateRating: seprateRating,
          deviations: rowDeviations
        };
        const tableRow = this.renderer.createElement('div');
        this.renderer.addClass(tableRow, 'rating-table-row');
        const rowCells: any = [
          { content: mainRow.question, parentClassName: '', childClassName: '' },
          { content: mainRow.totalCount, parentClassName: 'rating-response-count-span', childClassName: '', deviation: mainRow.deviations?.responses },
          { content: mainRow.rating, parentClassName: 'rating-rating-span', childClassName: '', deviation: mainRow.deviations?.rating },
        ];
        rowCells.push(
          { content: mainRow.totalTop, parentClassName: 'rating-top-span', childClassName: '', deviation: mainRow.deviations?.top },
          { content: mainRow.totalMid, parentClassName: 'rating-top-span', childClassName: '', deviation: mainRow.deviations?.mid },
          { content: mainRow.totalBottom, parentClassName: 'rating-top-span', childClassName: '', deviation: mainRow.deviations?.bottom }
        );
        rowCells.push({content: 'Click to view', parentClassName: '', childClassName: 'rating-distribution-button', distribution: mainRow.seprateRating});
        rowCells.forEach((cell, index) => {
          const parentSpan = this.renderer.createElement('span');
          let deviationTarget: HTMLElement = parentSpan;
          if(cell.parentClassName && cell.childClassName) {
            this.renderer.addClass(parentSpan, cell.parentClassName);
            cell.content.forEach(item => {
              const childSpan = this.renderer.createElement('span');
              this.renderer.addClass(childSpan, cell.childClassName);
              const labelSpan = this.renderer.createElement('span');
              const labelText = this.renderer.createText(item.label);
              this.renderer.appendChild(labelSpan, labelText);
              this.renderer.appendChild(childSpan, labelSpan);
              const countSpan = this.renderer.createElement('span');
              const countText = this.renderer.createText(item.response);
              this.renderer.appendChild(countSpan, countText);
              this.renderer.appendChild(childSpan, countSpan);
              this.renderer.appendChild(parentSpan, childSpan);
            });
          } else if(cell.childClassName) {
            const uniqueId = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
            const childSpan = this.renderer.createElement('span');
            this.renderer.addClass(childSpan, cell.childClassName);
            const childSpanText = this.renderer.createText(cell.content);
            this.renderer.appendChild(childSpan, childSpanText);
            this.renderer.appendChild(parentSpan, childSpan);
            this.renderer.setAttribute(childSpan, 'fieldId', String(uniqueId)+index);
            this.renderer.listen(childSpan, 'click', () => {
              this.showDistributionDropdown(cell, String(uniqueId)+index, 'all-questions-group-table');
            });
          } else if(cell.parentClassName) {
            this.renderer.addClass(parentSpan, cell.parentClassName);
            const childSpan = this.renderer.createElement('span');
            this.renderer.appendChild(childSpan, this.renderer.createText(cell.content));
            this.renderer.appendChild(parentSpan, childSpan);
            deviationTarget = childSpan;
          } else {
            const parentSpanText = this.renderer.createText(cell.content);
            if(index === 0) {
              const box = this.renderer.createElement('span');
              this.renderer.addClass(box, 'questionGroupBox');
              this.renderer.setStyle(box, 'cursor', 'default');
              this.renderer.appendChild(parentSpan, box);
            }
            this.renderer.appendChild(parentSpan, parentSpanText);
          }
          this.appendDeviationToRenderedCell(deviationTarget, cell.deviation);
          this.renderer.appendChild(tableRow, parentSpan);
        })
        this.renderer.appendChild(parentDiv, tableRow);
        if (index < detailedFeedbackItemsArray.length - 1) {
          const hr = this.renderer.createElement('hr');
          this.renderer.setStyle(hr, 'width', '95%');
          this.renderer.setStyle(hr, 'border', 'none');
          this.renderer.setStyle(hr, 'border-bottom', '1px solid black');
          this.renderer.setStyle(hr, 'margin', '0px auto');
          this.renderer.appendChild(parentDiv, hr);
        }
      })
    } else {
      console.warn('Parent div not found for fieldId:', fieldId);
    }
  }

  private aggregateGroupMetrics(header: any, detailedRating: any[]): {
    rawTotal: number;
    rawTop: number;
    rawMid: number;
    rawBottom: number;
    rating: number | string;
    hasMid: boolean;
    seprateRating: any[];
  } {
    const fieldIds = _.map(header.subTableName, 'field_id');
    const category = this.responseAnalyticsService.getRatingBandsByRaterType(header?.scale_rater_type);
    let totalResponse = 0;
    let sumOfRating = 0;
    let totalTop = 0;
    let totalMid = 0;
    let totalBottom = 0;
    let rating: any = 0;
    const seprateRating: any[] = [];
    const hasMid = !(
      header?.scale_rater_type == '-5 to +5' ||
      header?.scale_rater_type == '-5 to 5' ||
      header?.scale_rater_type == '1' ||
      (header?.scale_rater_type == '8' && !header?.is_primary_rating)
    );
    for (const key in header?.prop || {}) {
      seprateRating.push({ ...header.prop[key], count: 0, percentage: '0%' });
    }
    fieldIds.forEach((fieldId: string) => {
      const result = _.find(detailedRating, { field_id: fieldId });
      totalResponse += result?.number_of_user_rated || 0;
      sumOfRating += result?.sum || 0;
      if (result?.detailed_rating_details?.length > 0) {
        result.detailed_rating_details.forEach((detailedRatingDetail: any) => {
          const ratings = detailedRatingDetail.rating || 0;
          const numberOfUsersRated = detailedRatingDetail?.number_of_user_rated || 0;
          if (category?.bottom?.includes(ratings)) {
            totalBottom += numberOfUsersRated;
          } else if (category?.mid?.includes(ratings)) {
            totalMid += numberOfUsersRated;
          } else if (category?.top?.includes(ratings)) {
            totalTop += numberOfUsersRated;
          }
        });
      }
    });
    if (header?.scale_rater_type == '0-10' || header?.scale_rater_type == '1-5') {
      rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
      if (rating !== 'N/A') {
        if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
          rating = Math.floor(rating);
        } else if (rating > 0 && rating % 1 === 0.5) {
          rating = Math.ceil(rating);
        } else {
          rating = Math.round(rating);
        }
      }
    } else {
      rating = totalResponse > 0 ? parseFloat((sumOfRating / totalResponse).toFixed(2)) : 'N/A';
    }
    fieldIds.forEach((fieldId: string) => {
      const result = _.find(detailedRating, { field_id: fieldId });
      if (result?.detailed_rating_details?.length > 0) {
        result.detailed_rating_details.forEach((detailedRatingDetail: any) => {
          const ratingObj = seprateRating.find((items: any) => items.value == detailedRatingDetail.rating);
          if (ratingObj) {
            ratingObj.count += detailedRatingDetail?.number_of_user_rated || 0;
            ratingObj.percentage =
              totalResponse > 0 ? (((ratingObj.count || 0) / totalResponse) * 100).toFixed(1) + '%' : '0%';
          }
        });
      }
    });
    return {
      rawTotal: totalResponse,
      rawTop: totalTop,
      rawMid: totalMid,
      rawBottom: totalBottom,
      rating,
      hasMid,
      seprateRating
    };
  }

  private computeGroupRowDeviations(header: any, response: any): {
    responses?: any;
    rating?: any;
    top?: any;
    mid?: any;
    bottom?: any;
  } {
    if (!this.showComparisonFlag || typeof Helpers === 'undefined' || !Helpers.getFieldDeviation) {
      return {};
    }
    try {
      const currentDetailedRating = _.get(_.find(response?.data?.response, { key: 'current' }), 'detailed_rating', []);
      const previousDetailedRating = _.get(_.find(response?.data?.response, { key: 'previous' }), 'detailed_rating', []);
      const current = this.aggregateGroupMetrics(header, currentDetailedRating || []);
      const previous = this.aggregateGroupMetrics(header, previousDetailedRating || []);
      const parseRating = (value: number | string): number | null => {
        if (value === 'N/A' || value == null || value === '') {
          return null;
        }
        const parsed = typeof value === 'number' ? value : parseFloat(String(value));
        return isNaN(parsed) ? null : parsed;
      };
      const currentRating = parseRating(current.rating);
      const previousRating = parseRating(previous.rating);
      const deviations: any = {};
      const responsesDev = Helpers.getFieldDeviation(current.rawTotal, previous.rawTotal);
      const topDev = Helpers.getFieldDeviation(current.rawTop, previous.rawTop);
      const bottomDev = Helpers.getFieldDeviation(current.rawBottom, previous.rawBottom);
      if (shouldShowDeviation(responsesDev)) {
        deviations.responses = responsesDev;
      }
      if (shouldShowDeviation(topDev)) {
        deviations.top = topDev;
      }
      if (shouldShowDeviation(bottomDev)) {
        deviations.bottom = bottomDev;
      }
      if (current.rawTotal > 0) {
        const ratingDev = Helpers.getFieldDeviation(currentRating ?? 0, previousRating ?? 0);
        if (shouldShowDeviation(ratingDev)) {
          deviations.rating = ratingDev;
        }
      }
      if (current.hasMid) {
        const midDev = Helpers.getFieldDeviation(current.rawMid, previous.rawMid);
        if (shouldShowDeviation(midDev)) {
          deviations.mid = midDev;
        }
      }
      return deviations;
    } catch (error) {
      console.error('Error computing group row deviations:', error);
      return {};
    }
  }

  private prepareDataForAllGroup(header: any, response: any): any {
    const currentDetailedRating = _.get(_.find(response.data.response, { key: 'current' }), 'detailed_rating', []);
    const metrics = this.aggregateGroupMetrics(header, currentDetailedRating || []);
    return {
      totalResponse: this.responseAnalyticsService.formatNumber(metrics.rawTotal),
      totalTop: this.responseAnalyticsService.formatNumber(metrics.rawTop),
      totalMid: metrics.hasMid ? this.responseAnalyticsService.formatNumber(metrics.rawMid) : '',
      totalBottom: this.responseAnalyticsService.formatNumber(metrics.rawBottom),
      rating: metrics.rating,
      seprateRating: metrics.seprateRating,
      rawTotal: metrics.rawTotal
    };
  }

  private prepareDataForTextType(fieldId, response): any {
    const initialValue = 0;
    let totalResponse = response.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.number_of_user_rated,
      initialValue,
    );
  
    const questionData = _.find(Helpers?.brandDetails?.detailed_feedback_items, { field_id: fieldId });
    if (_.isEmpty(questionData)) {
      return;
    }
  
    // Only prepare minimal headers for text-based questions
    const tableHeader = {
      rating: '', 
      top: '',    
      mid: '',    
      bottom: '',
      display: ''
    };
   // Only show required row for text-based questions
    const tableRow = {
      question: questionData?.question || questionData?.text || '',
      totalCount: totalResponse,
      rating: '',
      totalTop: '',
      totalMid: '',
      totalBottom: '',
      topPercentage: '',
      midPercentage: '',
      bottomPercentage: '',
    };
    // Now send to render function but indicate a new type (like "textType")
    this.prepareTableForAllQuestions(tableHeader, tableRow, 'textType', fieldId);
  }
  
  private prepareTableDataForAllQuestions(fieldId: any, data: any, tableType: string): void {
    this.isError = false;
    this.isLoading = false;
    const detailedFeedbackItems = _.find(Helpers?.brandDetails?.detailed_feedback_items, { field_id: fieldId });
    if (_.isEmpty(detailedFeedbackItems)) {
      return;
    }
    const headerLabels = this.getHeaderLabels(
      detailedFeedbackItems?.main_rater_type, 
      detailedFeedbackItems?.scale_rater_type, 
      detailedFeedbackItems?.is_primary_rating
    );
    const selectionRowData = tableType === 'selectionBased'
      ? this.getSelectionBasedData(fieldId, data)
      : null;
    if (tableType === 'selectionBased' && selectionRowData) {
      this.attachSelectionOptionDeviations(fieldId, selectionRowData, data, detailedFeedbackItems);
    }
    const rowData = {
      question: detailedFeedbackItems?.question || '',
      ...(tableType === 'ratingBased'
        ? this.getRatingBasedData(fieldId, data, detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating, 'allQuestion')
        : selectionRowData),
      deviations: this.computeAllQuestionRowDeviations(fieldId, tableType, data, detailedFeedbackItems)
    };
    let totalCount = Number(rowData.totalCount.replace(/,/g, ''));
    if(totalCount > 0) {
      this.prepareTableForAllQuestions(headerLabels, rowData, tableType, fieldId);
    }
  }

  private prepareTableForAllQuestions(headerLabels: any, rowData: any, tableType: string, fieldId: any): void {
    let scoreDisplayName: string = _.get(Helpers, 'brandDetails.label_configs.Score.value', 'Score');
    if(!scoreDisplayName) {
        scoreDisplayName = 'Score';
    }
    const selectionQuestionMeta = _.find(Helpers?.brandDetails?.detailed_feedback_items, { field_id: fieldId });
    const isSelectionDistributionColumn =
      tableType === 'selectionBased' &&
      (selectionQuestionMeta?.type === 'multi-select' || selectionQuestionMeta?.type === 'single-select');
    this.isLoading = false;
    this.changeDetector.detectChanges();
    const parentDiv = this.el.nativeElement.querySelector('.all-questions-table');
    const tableContainer = this.renderer.createElement('div');
    this.renderer.addClass(tableContainer, tableType === 'ratingBased' ? 'rating-table-container' : 'selection-table-container');
    if (this.usesAllQuestionsMetricLayout()) {
      this.renderer.addClass(tableContainer, 'all-questions-metric-layout');
    }
    // ======================== Table header start ========================
    const tableHeader = this.renderer.createElement('div');
    this.renderer.addClass(tableHeader, tableType === 'ratingBased' ? 'rating-table-header' : 'selection-table-header');
    if (isSelectionDistributionColumn) {
      this.renderer.addClass(tableHeader, 'selection-table-has-distribution');
    }
    const headerCells = [
      { content: 'Question', className: '' },
      { content: 'Response Count', className: tableType === 'ratingBased' ? 'rating-response-count-span' : 'selection-response-count-span' },
      { content: tableType === 'ratingBased' ? scoreDisplayName : '', className: tableType === 'ratingBased' ? 'rating-rating-span' : 'selection-rating-span' },
    ];   
    if (tableType === 'ratingBased') {
      headerCells.push(
        { content: headerLabels?.top, className: 'rating-top-span' },
        { content: headerLabels?.mid, className: 'rating-top-span' },
        { content: headerLabels?.bottom, className: 'rating-top-span' },
        { content: 'Distribution', className: '' }
      );
    } else if (tableType === 'selectionBased') {
      headerCells.push(
        { content: 'Options', className: 'selection-top-span' },
        { content: 'Count', className: 'selection-top-span' }
      );
      if (isSelectionDistributionColumn) {
        headerCells.push({ content: 'Distribution', className: 'selection-top-span-distribution-header' });
      }
    }
    // Don't add any additional headerCells for 'textType'
      headerCells.forEach(cell => {
      const parentSpan = this.renderer.createElement('span');
      if(cell.className) {
        this.renderer.addClass(parentSpan, cell.className);
        const childSpan = this.renderer.createElement('span');
        const childSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(childSpan, childSpanText);
        this.renderer.appendChild(parentSpan, childSpan);
      } else {
        const parentSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(parentSpan, parentSpanText);
      }
      this.renderer.appendChild(tableHeader, parentSpan);
    })
    this.renderer.appendChild(tableContainer, tableHeader);
    this.renderer.appendChild(parentDiv, tableContainer);
    // ======================== Table header end ========================
    
    // ======================== Table row start ========================
    const tableRow = this.renderer.createElement('div');
    this.renderer.addClass(tableRow, tableType == 'ratingBased' ? 'rating-table-row' : 'selection-table-row');
    if (isSelectionDistributionColumn) {
      this.renderer.addClass(tableRow, 'selection-table-has-distribution');
    }
    const rowCells: any = [
      { content: rowData.question, parentClassName: '', childClassName: '' },
      { content: rowData.totalCount, parentClassName: tableType === 'ratingBased' ? 'rating-response-count-span' : 'selection-response-count-span', childClassName: '', style: {'margin-left': tableType === 'selectionBased' ? '-3px' : ''}, deviation: rowData.deviations?.responses },
      { content: tableType === 'ratingBased' ? rowData.rating : '', parentClassName: tableType === 'ratingBased' ? 'rating-rating-span' : 'selection-rating-span', childClassName: '', deviation: rowData.deviations?.rating },
    ];
    
    // Only add extra columns if needed
    if (tableType === 'ratingBased') {
      rowCells.push(
        { content: rowData.totalTop, parentClassName: 'rating-top-span', childClassName: '', deviation: rowData.deviations?.top },   // Promoters
        { content: rowData.totalMid, parentClassName: 'rating-top-span', childClassName: '', deviation: rowData.deviations?.mid },   // Passives
        { content: rowData.totalBottom, parentClassName: 'rating-top-span', childClassName: '', deviation: rowData.deviations?.bottom },// Detractors
        { content: 'Click to view', parentClassName: '', childClassName: 'rating-distribution-button', distribution: rowData.seprateRating }
      );
    } else if (tableType === 'selectionBased') {
      rowCells.push(
        { content: rowData.options, parentClassName: 'selection-top-span-box', childClassName: 'selection-count-row-data' }
      );
      if (isSelectionDistributionColumn) {
        rowCells.push({
          content: this.buildSelectionDistributionRows(rowData),
          parentClassName: 'selection-top-span-box',
          childClassName: 'selection-distribution-row-data',
          isDistributionColumn: true,
        });
      }
    }
    // For 'textType', do not push additional cells
    
    rowCells.forEach(cell => {
      const parentSpan = this.renderer.createElement('span');
      let deviationTarget: HTMLElement = parentSpan;
      if(cell.parentClassName && cell.childClassName) {
        this.renderer.addClass(parentSpan, cell.parentClassName);
        cell.content.forEach(item => {
          const childSpan = this.renderer.createElement('span');
          this.renderer.addClass(childSpan, cell.childClassName);
          if (cell.isDistributionColumn) {
            const distributionText = this.renderer.createText(item.text ?? '0%');
            this.renderer.appendChild(childSpan, distributionText);
          } else {
            const labelSpan = this.renderer.createElement('span');
            const labelText = this.renderer.createText(item.label);
            this.renderer.appendChild(labelSpan, labelText);
            if (item.is_deleted) {
              const asteriskSpan = this.renderer.createElement('span');
              this.renderer.addClass(asteriskSpan, 'selection-deleted-asterisk');
              this.renderer.setStyle(asteriskSpan, 'color', '#e53935');
              this.renderer.setStyle(asteriskSpan, 'cursor', 'help');
              this.renderer.setAttribute(asteriskSpan, 'title', MSG_CONST.DELETED_OPTION_TOOLTIP);
              this.renderer.appendChild(asteriskSpan, this.renderer.createText('*'));
              this.renderer.appendChild(labelSpan, asteriskSpan);
            }
            this.renderer.appendChild(childSpan, labelSpan);
            const countSpan = this.renderer.createElement('span');
            this.renderer.addClass(countSpan, 'selection-option-count-span');
            if (this.usesAllQuestionsMetricLayout()) {
              const wrapper = this.renderer.createElement('span');
              this.renderer.addClass(wrapper, 'metric-cell-value');
              const primary = this.renderer.createElement('span');
              this.renderer.addClass(primary, 'cell-primary-value');
              this.renderer.appendChild(primary, this.renderer.createText(item.response));
              this.renderer.appendChild(wrapper, primary);
              this.renderer.appendChild(countSpan, wrapper);
              this.appendAllQuestionsTableDeviation(wrapper, item.deviation, true);
            } else {
              this.renderer.appendChild(countSpan, this.renderer.createText(item.response));
              if (shouldShowDeviation(item.deviation)) {
                this.appendDeviationToRenderedCell(countSpan, item.deviation);
              }
            }
            this.renderer.appendChild(childSpan, countSpan);
          }
          this.renderer.appendChild(parentSpan, childSpan);
        });
      } else if(cell.childClassName) {
        const childSpan = this.renderer.createElement('span');
        this.renderer.addClass(childSpan, cell.childClassName);
        const childSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(childSpan, childSpanText);
        this.renderer.appendChild(parentSpan, childSpan);
        this.renderer.setAttribute(childSpan, 'fieldId', fieldId);
        this.renderer.listen(childSpan, 'click', () => {
          this.showDistributionDropdown(cell, fieldId, 'all-questions-table');
        });
        
      } else if(cell.parentClassName) {
        this.renderer.addClass(parentSpan, cell.parentClassName);
        deviationTarget = this.renderAllQuestionsTableCell(parentSpan, cell.content, cell.parentClassName);
      } else {
        const parentSpanText = this.renderer.createText(cell.content);
        this.renderer.appendChild(parentSpan, parentSpanText);
      }
      this.appendAllQuestionsTableDeviation(deviationTarget, cell.deviation, this.isAllQuestionsMetricColumn(cell.parentClassName));
      this.renderer.appendChild(tableRow, parentSpan);
    })
    this.renderer.appendChild(tableContainer, tableRow);
    this.renderer.appendChild(parentDiv, tableContainer);
    // ======================== Table row end ==========================
  }

  private showDistributionDropdown(cell: any, fieldId: any, tableType: string): void {
    const parentDiv = document.querySelector(`.${tableType}`);
    if (parentDiv) {
      const childElements = parentDiv.querySelectorAll('*');
      childElements.forEach(child => {
        if (child.matches(`span[fieldid='${fieldId}']`) || child.matches(`div[fieldid='${fieldId}']`)) {
          return;
        }
        if (child.classList.contains('active')) {
          child.classList.remove('active');
        }
        if(child.classList.contains('view-to-click')) {
          child.remove();
        }
      });
    }
    const selector = `span[fieldid='${fieldId}']`;
    const selectorTwo = `div[fieldid='${fieldId}']`;
    const span = document.querySelector(selector);
    if (span) {
      if (span.classList.contains('active')) {
        span.classList.remove('active');
        document.querySelector(selectorTwo)?.remove();
      } else {
        span.classList.add('active');
        this.showHoverMessage(span, cell, fieldId);
        this.addOutsideClickListener(span, fieldId);
      }
    }
  }

  private showHoverMessage(span: any, cell: any, fieldId: any): void {
    let sortedCell: any = cell.distribution.sort((a, b) => b.value - a.value);
    const parentSpan = span.parentNode;
    parentSpan.style.position = 'relative';
    const viewToClick = document.createElement('div');
    viewToClick.classList.add('view-to-click');
    viewToClick.setAttribute('fieldId', fieldId)
    viewToClick.style.position = 'absolute';
    viewToClick.style.top = `55px`;
    viewToClick.style.marginRight = `270px`;
    viewToClick.style.width = `369px`;
    viewToClick.style.backgroundColor = '#ffffff';
    viewToClick.style.borderRadius = '10px';
    viewToClick.style.boxShadow = '0px 10px 20px #00000033';
    viewToClick.style.zIndex = '1000';
    sortedCell.forEach((item, index) => {
      const boxes = document.createElement('div');
      boxes.style.width = '100%';
      boxes.style.padding = '12px';
      boxes.style.display = 'flex';
      boxes.style.justifyContent = 'space-between';
      boxes.style.alignItems = 'center';
      if(index < sortedCell.length-1) {
        boxes.style.borderBottom = '1px solid var(--border-color)';
      }
      const spanOne = document.createElement('span');
      spanOne.textContent = `${item.value}: (${item.label})`;
      const spanTwo = document.createElement('span');
      spanTwo.textContent = `${item.count} (${item.percentage})`;
      boxes.appendChild(spanOne);
      boxes.appendChild(spanTwo);
      viewToClick.appendChild(boxes);
    })
    parentSpan.appendChild(viewToClick);
  }

  private addOutsideClickListener(span: any, fieldId: any): void {
    const closeHandler = (event: MouseEvent) => {
      const viewBox = document.querySelector(`div[fieldid='${fieldId}']`);
      const button = document.querySelector(`span[fieldid='${fieldId}']`);
      if (viewBox && !viewBox.contains(event.target as Node) && button&& !button.contains(event.target as Node)) {
        button.classList.remove('active');
        viewBox.remove();
        document.removeEventListener('click', closeHandler);
      }
    };
    document.addEventListener('click', closeHandler);
  }

  setMinMaxValueForLineChart(raterType:any) {
    if (raterType && this.raterTypeDetails[raterType]) {
      this.lineChartPlugins.min = this.raterTypeDetails[raterType]['min']
      this.lineChartPlugins.max = this.raterTypeDetails[raterType]['max']
    } else {
      this.lineChartPlugins.min = null;
      this.lineChartPlugins.max = null;
    }
  }

  private callGetOverallRating(): void {
    let payload: any = {
      manager_type: 2,
      brand_id: _.get(Helpers, 'brandDetails._id', null),
      main_rater_type: _.get(Helpers, 'brandDetails.main_rater_type', 2),
      shop_id_list: [],
      hierarchy_stack: _.get(Helpers, 'hierarchyStack', null),
      question_aggs: true,
      use_es: true,
      is_custom_date_range_selected: _.get(Helpers, 'datePicker.isCustomDateRangeSelected', false),
      dashboard_version: 2,
      from: _.get(Helpers, 'datePicker.startDate', null),
      to: _.get(Helpers, 'datePicker.endDate', null),
      universal_filter: _.get(Helpers, 'universalFilter', null),
      group_alias_key: this.getGroupAliasKey()
    };
    payload = _.omitBy(payload, _.isNil);
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getoverallRating(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response?.message === 'success') {
        this.lastOverviewRatingResponse = response;
        if(this.active) {
          this.prepareOverviewGroupDataForRatingType(response);
        } else {
          this.prepareOverviewDataForRatingType(response);
        }
      } else {
        this.isRatingCardError = true;
        this.selectionBasedCardError = true;
        this.isLoading = false;
        this.isError = true;
      }
    })
  }

  private prepareOverviewDataForRatingType(response: any, textPreviousBucket?: any): void {
    const detailedFeedbackItems = _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.field_id === this.viewDropdownFieldId)[0];
    const questions = _.get(response, 'data.rating_details.detailed_rating.questions', []);
    const previousQuestions = _.get(response, 'data.rating_details.previous.detailed_rating.questions', []);
    let data = _.get(_.find(questions, { key: this.viewDropdownFieldId }), 'rating_number', null);
    const previousData = _.get(_.find(previousQuestions, { key: this.viewDropdownFieldId }), 'rating_number', null);
    if (_.size(detailedFeedbackItems) > 0) {
      if(this.selectedCardName == 'rating') {
        let headerLabels: any = this.getHeaderLabels(detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating);
        let responses = this.getRatingBasedData(this.viewDropdownFieldId, data, detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating, 'ratingBased');
        this.setOverviewDeviationsFromRatingData(
          this.viewDropdownFieldId,
          data,
          previousData,
          detailedFeedbackItems?.main_rater_type,
          detailedFeedbackItems?.scale_rater_type,
          detailedFeedbackItems?.is_primary_rating,
          'ratingBased'
        );
        this.totalResponse = responses?.totalCount;
        this.ratingnumber = responses?.rating;
        this.topPercentage = responses?.topPercentage;
        this.midPercentage = responses?.midPercentage;
        this.bottomPercentage = responses?.bottomPercentage;
        this.ratingDisplay = headerLabels?.rating;
        this.rating = headerLabels?.display;
        this.topName = headerLabels?.top;
        this.midName = headerLabels?.mid;
        this.bottomName = headerLabels?.bottom;
        this.totalTop = responses?.totalTop;
        this.totalMid = responses?.totalMid;
        this.totalBottom = responses?.totalBottom;
        this.prepareOverviewBarchartRatingCard(responses);
      } else if(this.selectedCardName == 'text') {
        const detailedFeedbackItemsText = _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.field_id === 'primary_rating')[0];
        let headerLabels: any = this.getHeaderLabels(detailedFeedbackItemsText?.scale_rater_type, detailedFeedbackItemsText?.scale_rater_type, true);
        let responses = this.getRatingBasedData('primary_rating', response, detailedFeedbackItemsText?.scale_rater_type, detailedFeedbackItemsText?.scale_rater_type, true, 'textBased');
        this.setOverviewDeviationsFromRatingData(
          'primary_rating',
          response,
          textPreviousBucket ?? null,
          detailedFeedbackItemsText?.scale_rater_type,
          detailedFeedbackItemsText?.scale_rater_type,
          true,
          'textBased'
        );
        this.totalResponse = this.responseAnalyticsService.formatNumber(Number((responses?.totalTop).replace(/,/g, '')) + Number((responses?.totalMid).replace(/,/g, '')) + Number((responses?.totalBottom).replace(/,/g, '')));
        this.ratingnumber = responses?.rating;
        this.topPercentage = responses?.topPercentage;
        this.midPercentage = responses?.midPercentage;
        this.bottomPercentage = responses?.bottomPercentage;
        this.ratingDisplay = headerLabels?.rating;
        this.rating = headerLabels?.display;
        this.topName = headerLabels?.top;
        this.midName = headerLabels?.mid;
        this.bottomName = headerLabels?.bottom;
        this.totalTop = responses?.totalTop;
        this.totalMid = responses?.totalMid;
        this.totalBottom = responses?.totalBottom;
        this.prepareOverviewBarchartRatingCard(responses);
      }else {
        let data: any = questions;
        let responses = this.getSelectionBasedData(this.viewDropdownFieldId, data);
        const previousResponses = this.getSelectionBasedData(this.viewDropdownFieldId, previousQuestions);
        this.toTotalRatedOption = responses.totalCount || 0;
        const getValue = value => Number(String(value).replace(/,/g, ""));
        const sortedOptions = responses.options.sort((a, b) => getValue(b.response) - getValue(a.response));
        this.mostSelectedKeyOptions = sortedOptions[0];
        const previousMostSelected = previousResponses?.options?.find(
          (opt: any) => opt.value === this.mostSelectedKeyOptions?.value
            && (!this.mostSelectedKeyOptions?.field_id || opt.field_id === this.mostSelectedKeyOptions.field_id)
        );
        this.setSelectionOverviewDeviation(
          responses.totalCount,
          previousResponses?.totalCount,
          this.mostSelectedKeyOptions?.response,
          previousMostSelected?.response
        );
        let obj: any = {
          labels: [],
          dataset: [],
          options: responses.options,
          totalCount: getValue(responses.totalCount)
        };
        responses.options.forEach(item => {
          obj.labels.push(item.label);
          obj.dataset.push(getValue(item.response));
        })
        this.horizonatlBarChartDynamicHeight = (obj.dataset.length * 50) + 'px';
        this.horizonatlBarChart = obj;
        if(this.toTotalRatedOption != '0') {
          this.selectionBasedCardLoading = false;
          this.selectionBasedCardError = false;
        } else {
          this.selectionBasedCardLoading = false;
          this.selectionBasedCardError = true;
        }
      }
    } else {
      this.isLoading = false;
      this.isError = true;
    }
  }

  private prepareOverviewGroupDataForRatingType(response: any): void {
    const questions = response?.data?.rating_details?.detailed_rating?.questions;
    const detailedFeedbackItems = Helpers?.brandDetails?.detailed_feedback_items || [];
    const detailedFeedbackItem = detailedFeedbackItems.find(item =>
      item.dynamic_properties?.question_group?.some(group => group.id === this.viewDropdownFieldId)
    );
    let headerLabels = this.getHeaderLabels(
      detailedFeedbackItem?.main_rater_type, 
      detailedFeedbackItem?.scale_rater_type, 
      false
    );
    const detailedFeedbackItemsArray = _.filter(detailedFeedbackItems, obj => 
      obj.dynamic_properties && _.some(obj.dynamic_properties.question_group, { id: this.viewDropdownFieldId })
    );
    let totalResponse = 0;
    let totalBottom = 0;
    let totalMid = 0;
    let totalTop = 0;
    let sumOfPrimaryRating = 0;
    let rating: any = 'N/A';
    const category = this.responseAnalyticsService.getRatingBandsByRaterType(detailedFeedbackItem?.scale_rater_type);
    detailedFeedbackItemsArray.forEach(fieldId => {
      const ratingNumber = _.get(questions, `${fieldId.field_id}.rating_number`);
      for(let key in ratingNumber) {
        let ratings = Number(key);
        if(key != 'doc_count_error_upper_bound' && key != 'sum_other_doc_count') {
          const numberOfUsersRated = ratingNumber[key]?.doc_count || 0;
          if (category.bottom.includes(ratings)) {
            totalBottom += numberOfUsersRated;
          } else if (category?.mid && category?.mid.includes(ratings)) {
            totalMid += numberOfUsersRated;
          } else if (category.top.includes(ratings)) {
            totalTop += numberOfUsersRated;
          }
          sumOfPrimaryRating = sumOfPrimaryRating + (ratingNumber[key]?.doc_count * ratings);
          totalResponse = totalResponse + (ratingNumber[key]?.doc_count || 0);
        }
      }
    });
    if(detailedFeedbackItem?.scale_rater_type == '0-10' || detailedFeedbackItem?.scale_rater_type == '1-5') {
      rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
      if (rating !== 'N/A') {
        if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
          rating = Math.floor(rating);
        } else if (rating > 0 && rating % 1 === 0.5) {
          rating = Math.ceil(rating);
        } else {
          rating = Math.round(rating);
        }
      }
    } else {
      rating = totalResponse > 0 ? (sumOfPrimaryRating / totalResponse).toFixed(2) : 'N/A';
    }
    this.totalResponse = this.responseAnalyticsService.formatNumber(totalResponse);
    this.ratingDisplay = headerLabels?.rating;
    this.rating = headerLabels?.display;
    this.topName = headerLabels?.top;
    this.midName = headerLabels?.mid;
    this.bottomName = headerLabels?.bottom;
    this.totalTop = this.responseAnalyticsService.formatNumber(totalTop);
    this.totalMid = this.responseAnalyticsService.formatNumber(totalMid);
    this.totalBottom = this.responseAnalyticsService.formatNumber(totalBottom);
    this.ratingnumber = rating;
    this.topPercentage = totalResponse > 0 ? ((totalTop/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalTop/totalResponse)*100) + '%' : ((totalTop/totalResponse)*100).toFixed(1) + '%' : '0%';
    this.midPercentage = totalResponse > 0 ? ((totalMid/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalMid/totalResponse)*100) + '%' : ((totalMid/totalResponse)*100).toFixed(1) + '%' : '0%';
    this.bottomPercentage = totalResponse > 0 ? ((totalBottom/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalBottom/totalResponse)*100) + '%' : ((totalBottom/totalResponse)*100).toFixed(1) + '%' : '0%';
    let seprateRating: any = [];
    for(let key in detailedFeedbackItem?.prop) {
      seprateRating.push({...detailedFeedbackItem?.prop[key], count: 0, percentage: '0%'});
    }
    detailedFeedbackItemsArray.forEach(item => {
      const ratingNumber = _.get(questions, `${item.field_id}.rating_number`);
      if(_.size(ratingNumber) === 0) {
        this.ratingCardLoading = false;
        this.isRatingCardError = true;
        return;
      }
      Object.keys(ratingNumber).forEach(key => {
        if(key != 'doc_count_error_upper_bound' && key != 'sum_other_doc_count') {
          let ratingObj = seprateRating.find(items => items.value == Number(key));
          ratingObj.count = ratingObj.count + ratingNumber[key]?.doc_count || 0;
          ratingObj.percentage = totalResponse > 0 ? (((ratingObj.count || 0) / totalResponse) * 100).toFixed(1) + '%' : '0%';
        }
      })
    })
    this.prepareOverviewBarchartRatingCard({fieldId: detailedFeedbackItem?.field_id, seprateRating: seprateRating})
    if (this.showComparisonFlag && this.lastCrossTabResponse) {
      this.setOverviewDeviationsFromGroupCrossTab(this.lastCrossTabResponse, this.viewDropdownFieldId);
    } else {
      this.clearOverviewDeviations();
    }
    if(totalResponse > 0) {
      this.isLoading = false;
      this.isError = false;
      this.ratingCardLoading = false;
      this.isRatingCardError = false;
    } else {
      this.isLoading = false;
      this.isError = false;
      this.ratingCardLoading = false;
      this.isRatingCardError = true;
    }
  }

  private prepareOverviewBarchartRatingCard(data: any): void {
    let obj: any = {
      labels: [],
      labelsName: [],
      labelsSynonyms: [],
      dataset: [{
        data: [],
        backgroundColor: [],
        hoverBackgroundColor: []
      }],
    };
    const sortedData = data?.seprateRating.sort((a: any, b: any) => Number(a.value) - Number(b.value));
    sortedData.forEach(item => {
      obj.labelsName.push(item?.label);
      obj.labelsSynonyms.push(this.getLabelSynonyms(item?.value, data?.fieldId));
      obj.labels.push(item?.value);
      obj.dataset[0].data.push(item?.count);
      obj.dataset[0].backgroundColor.push(item?.active_color);
      obj.dataset[0].hoverBackgroundColor.push(item?.active_color);
    })
    this.barChart = obj;
    if(this.totalResponse != '0') {
      this.ratingCardLoading = false;
      this.isRatingCardError = false;
      this.textCardLoading = false;
      this.isTextCardError = false;
    } else {
      this.ratingCardLoading = false;
      this.isRatingCardError = true;
      this.textCardLoading = false;
      this.isTextCardError = true;
    }
  }

  private getLabelSynonyms(rating: any, fieldId): any {
    const key = Number(rating);
    const detailedFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.field_id === fieldId)[0];
    const isPrimaryRating: boolean = detailedFeedbackItems?.is_primary_rating || detailedFeedbackItems?.is_primary_comment || false;
    let scalerRaterType: any = detailedFeedbackItems?.scale_rater_type;
    if(['0-10', '1-10', '7', '8', '9', '5', '-5 to 5', '-5 to +5'].includes(scalerRaterType) == false) {
      scalerRaterType =  _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.is_primary_rating === true)[0]?.scale_rater_type;
    }
    if(scalerRaterType == '0-10') {
      if (isPrimaryRating && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
        if(key >= 4) {
          return 'Promoters'
        } else if(key >= 3) {
          return 'Passives';
        } else if(key >= 1) {
          return 'Detractors';
        }
      }else {
        if(key >= 9) {
          return 'Promoters'
        } else if(key >= 7) {
          return 'Passives';
        } else if(key >= 0) {
          return 'Detractors';
        }
      }
    } else if(scalerRaterType == '1-10') {
      if(key >= 8) {
        return 'T3B';
      } else if(key >= 4) {
        return 'MB';
      } else if(key >= 1) {
        return 'B3B';
      }
    } else if(scalerRaterType == '7') {
      if(key >= 5) {
        return 'T2B';
      } else if(key >= 3) {
        return 'MB';
      } else if(key >= 1) {
        return 'B2B';
      }
    } else if(scalerRaterType == '5') {
      if(key >= 4) {
        return 'T2B';
      } else if(key >= 3) {
        return 'MB';
      } else if(key >= 1) {
        return 'B2B';
      }
    } else if(scalerRaterType == '9') {
      if(key >= 4) {
        return 'TB';
      } else if(key >= 2) {
        return 'MB';
      } else if(key >= 1) {
        return 'BB';
      }
    } else if(scalerRaterType == '-5 to 5' || scalerRaterType == '-5 to +5') {
      if(key >= 1) {
        return 'Positives';
      } else if(key >= 0) {
        return '';
      } else if(key >= -5) {
        return 'Negatives';
      }
    } else if(scalerRaterType == '8') {
      if(isPrimaryRating) {
        if(key >= 1) {
          return 'T3B';
        } else if(key >= 0) {
          return 'MB';
        } else if(key >= -3) {
          return 'B3B';
        }
      } else {
        if(key >= 1) {
          return 'Positives';
        } else if(key >= 0) {
          return '';
        } else if(key >= -3) {
          return 'Negatives';
        }
      }
    }
  }

  private refreshTrendChartIfNeeded(): void {
    if (!this.selectedOption) {
      return;
    }
    this.queueLineChartLoad();
    if (this.selectedCardName === 'rating') {
      this.queueResponseBarLoad();
    }
  }

  /** Hide the chart and collapse date/dropdown bursts into one request, same as Score Trends. */
  private queueLineChartLoad(): void {
    this.lineChartRequestId++;
    this.lineChartSubscription?.unsubscribe();
    this.lineChartSubscription = undefined;
    this.ratingLineChartCardLoading = true;
    this.isratingLineChartCardError = false;
    this.lineChartTrigger$.next();
  }

  /** Hide the chart and collapse date/dropdown bursts into one request, same as Score Trends. */
  private queueResponseBarLoad(): void {
    this.responseBarRequestId++;
    this.responseBarSubscription?.unsubscribe();
    this.responseBarSubscription = undefined;
    this.ratingResponseBarChartLoading = true;
    this.isRatingResponseBarChartError = false;
    this.responseBarTrigger$.next();
  }

  private callTrendDataRatingSummary(): void {
    const requestId = this.lineChartRequestId;
    this.lineChartSubscription?.unsubscribe();
    this.lineChartSubscription = undefined;
    const event = this.lineChartTrendEvents;
    if (event?.trend_type == null || event?.trend_type == undefined) {
      return;
    }
    const mainRaterType = Helpers?.brandDetails?.main_rater_type;
    if (!mainRaterType || mainRaterType == 2) {
      if (requestId !== this.lineChartRequestId) {
        return;
      }
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = true;
      return;
    }
    this.ratingLineChartCardLoading = true;
    this.isratingLineChartCardError = false;
    const trendType = event.trend_type;
    const payload = this.getTrendSummaryPayload(trendType);
    this.lineChartSubscription = this.responseAnalyticsService.getTrendDataRatingSummary(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (requestId !== this.lineChartRequestId) {
          return;
        }
        if (response?.message === 'Success') {
          if (this.active) {
            this.prepareRatingLineChartForGroupedQuestion(response);
          } else {
            this.prepareLineChartForRatingType(response);
          }
        } else {
          this.ratingLineChartCardLoading = false;
          this.isratingLineChartCardError = true;
        }
      },
      error: () => {
        if (requestId !== this.lineChartRequestId) {
          return;
        }
        this.ratingLineChartCardLoading = false;
        this.isratingLineChartCardError = true;
      }
    });
  }

  private callApiForResponseBar(): void {
    const requestId = this.responseBarRequestId;
    const trendType = this.barChartTrendType;
    this.responseBarSubscription?.unsubscribe();
    this.responseBarSubscription = undefined;
    if (trendType == null || trendType === '') {
      return;
    }
    const mainRaterType = Helpers?.brandDetails?.main_rater_type;
    if (!mainRaterType || mainRaterType == 2) {
      if (requestId !== this.responseBarRequestId) {
        return;
      }
      this.ratingResponseBarChartLoading = false;
      this.isRatingResponseBarChartError = true;
      return;
    }
    this.ratingResponseBarChartLoading = true;
    this.isRatingResponseBarChartError = false;
    const payload = this.getTrendSummaryPayload(trendType);
    this.responseBarSubscription = this.responseAnalyticsService.getTrendDataRatingSummary(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (requestId !== this.responseBarRequestId || trendType !== this.barChartTrendType) {
          return;
        }
        if (response?.message === 'Success') {
          this.prepareResponseBarChart(response, trendType);
        } else {
          this.ratingResponseBarChartLoading = false;
          this.isRatingResponseBarChartError = true;
        }
      },
      error: () => {
        if (requestId !== this.responseBarRequestId) {
          return;
        }
        this.ratingResponseBarChartLoading = false;
        this.isRatingResponseBarChartError = true;
      }
    });
  }

  private getTrendSummaryPayload(trendType: any): any {
    let payload: any = {
      brand_id: _.get(Helpers, 'brandDetails._id', null),
      group_id: null,
      main_rater_type: _.get(Helpers, 'brandDetails.main_rater_type', 2),
      trend_type: trendType,
      from: _.get(Helpers, 'datePicker.startDate', null),
      to: _.get(Helpers, 'datePicker.endDate', null),
      caller: 1,
      use_es: true,
      questions: null,
      shop_id: null,
      shop_id_list: [],
      date_filter_type: _.get(Helpers, 'datePicker.dateFilterType', 1),
      universal_filter: _.get(Helpers, 'universalFilter', null),
      hierarchy_stack: _.get(Helpers, 'hierarchyStack', null),
      group_alias_key: this.getGroupAliasKey()
    };
    payload = _.omitBy(payload, _.isNil);
    this.applyComparisonApiDateRange(payload);
    return payload;
  }

  private prepareLineChartForRatingType(response: any): void {
    const primaryQuestion = Helpers.brandDetails.detailed_feedback_items.filter(item => item.field_id == this.viewDropdownFieldId)[0];
    let data: any = response?.data?.response;
    this.lineChartCacheData = data;
    if(primaryQuestion?.type === "rating") {
      this.setMinMaxValueForLineChart(primaryQuestion?.scale_rater_type)
      this.prepareLineChartForRating(primaryQuestion, data);
    } else if(primaryQuestion?.type === "single-select") {
      this.prepareBarChartForSingleSelect(primaryQuestion, data);
    } if(primaryQuestion?.type === "multi-select") {
      this.prepareBarChartForMultiSelect(primaryQuestion, data);
    }
  }

  private prepareLineChartForRating(primaryQuestion, data): void {
    let headerLabels = this.getHeaderLabels(primaryQuestion?.main_rater_type, primaryQuestion?.scale_rater_type, false);
    let obj: any = {
      labels: [],
      xText: this.lineChartTrendEvents?.display,
      yText: headerLabels?.display === 'Rating' ? 'Rating' : headerLabels?.display,
      data: [],
      responses: []
    };
    data.forEach(item => {
      let datas = item?.detailed_rating.find(fieldId => fieldId.field_id == this.viewDropdownFieldId)?.detailed_rating || item?.detailed_rating.find(fieldId => fieldId.field_id == this.viewDropdownFieldId)?.detailed_rating_details;
      if(datas) {
        const label = this.prepareLabelsForChart(item?.time, this.lineChartTrendEvents?.trend_type);
        const ratingData = this.getRatingBasedData(this.viewDropdownFieldId, datas, primaryQuestion?.main_rater_type, primaryQuestion?.scale_rater_type, true, 'lineChart');
        const responseCount = parseTrendBarCount(ratingData?.totalCount);
        obj.labels.push(label);
        obj.data.push(Number(ratingData?.rating));
        obj.responses.push(this.responseAnalyticsService.formatNumber(responseCount));
      }
    })
    this.lineChart = obj;
    this.rememberLineChartCsvState(obj);
    if(obj.labels.length > 0) {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = false;
    } else {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = true;
    }
  }

  prepareRatingLineChartForGroupedQuestion(response) {
    const detailedFeedbackItem = this.getSelectedTrendQuestion();
    if (!detailedFeedbackItem) {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = true;
      return;
    }
    let headerLabels = this.getHeaderLabels(
      detailedFeedbackItem?.main_rater_type,
      detailedFeedbackItem?.scale_rater_type,
      false
    );
    this.setMinMaxValueForLineChart(detailedFeedbackItem?.scale_rater_type);
    let obj: any = {
      labels: [],
      xText: this.lineChartTrendEvents?.display,
      yText: headerLabels?.display === 'Rating' ? 'Rating' : headerLabels?.display,
      data: [],
      responses: []
    };
    const responses = response?.data?.response || [];
    this.lineChartCacheData = responses;
    responses.forEach(item => {
      const ratingDetails = this.getGroupedLineChartRatingDetails(item);
      if (ratingDetails.length > 0) {
        const label = this.prepareLabelsForChart(item?.time, this.lineChartTrendEvents?.trend_type);
        const ratingData = this.getRatingBasedData(
          detailedFeedbackItem.field_id,
          ratingDetails,
          detailedFeedbackItem?.main_rater_type,
          detailedFeedbackItem?.scale_rater_type,
          detailedFeedbackItem?.is_primary_rating,
          'lineChart'
        );
        const responseCount = parseTrendBarCount(ratingData?.totalCount);
        obj.labels.push(label);
        obj.data.push(Number(ratingData?.rating));
        obj.responses.push(this.responseAnalyticsService.formatNumber(responseCount));
      }
    });
    this.lineChart = obj;
    this.rememberLineChartCsvState(obj);
    if(obj.labels.length > 0) {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = false;
    } else {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = true;
    }
  }

  /**
   * Builds the Response Trend bar from its own date bucket, without touching the Trend line chart.
   */
  private prepareResponseBarChart(response: any, trendType?: any): void {
    const activeTrendType = trendType ?? this.barChartTrendType;
    const data = response?.data?.response || [];
    const primaryQuestion = this.active
      ? this.getSelectedTrendQuestion()
      : Helpers.brandDetails.detailed_feedback_items.filter(item => item.field_id == this.viewDropdownFieldId)[0];
    if (!primaryQuestion || primaryQuestion?.type !== 'rating') {
      this.responseBarCacheData = [];
      this.responseBarCsvChart = { labels: [], data: [], yText: '' };
      this.barChartCsvTrendEvent = {};
      this.ratingResponseBarChartLoading = false;
      this.isRatingResponseBarChartError = true;
      return;
    }
    const headerLabels = this.getHeaderLabels(
      primaryQuestion?.main_rater_type,
      primaryQuestion?.scale_rater_type,
      false
    );
    const barLabels: string[] = [];
    const csvRatings: any[] = [];
    const barSegments: TrendBarSegmentCounts[] = [];
    data.forEach(item => {
      const datas = this.active
        ? this.getGroupedLineChartRatingDetails(item)
        : (item?.detailed_rating?.find(fieldId => fieldId.field_id == this.viewDropdownFieldId)?.detailed_rating
          || item?.detailed_rating?.find(fieldId => fieldId.field_id == this.viewDropdownFieldId)?.detailed_rating_details);
      const hasData = this.active ? datas?.length > 0 : !!datas;
      if (!hasData) {
        return;
      }
      const label = this.prepareLabelsForChart(item?.time, activeTrendType);
      const ratingData = this.getRatingBasedData(
        this.active ? primaryQuestion.field_id : this.viewDropdownFieldId,
        datas,
        primaryQuestion?.main_rater_type,
        primaryQuestion?.scale_rater_type,
        this.active ? primaryQuestion?.is_primary_rating : true,
        'lineChart'
      );
      barLabels.push(label);
      csvRatings.push(Number(ratingData?.rating));
      barSegments.push({
        top: parseTrendBarCount(ratingData?.totalTop),
        mid: parseTrendBarCount(ratingData?.totalMid),
        bottom: parseTrendBarCount(ratingData?.totalBottom),
        response: parseTrendBarCount(ratingData?.totalCount),
      });
    });
    this.responseBarCacheData = data;
    this.barChartCsvTrendEvent = this.captureTrendEvent(this.barChartTrendEvents);
    this.responseBarCsvChart = {
      labels: [...barLabels],
      data: [...csvRatings],
      yText: headerLabels?.display === 'Rating' ? 'Rating' : (headerLabels?.display || ''),
    };
    this.cacheAndApplyRatingTrendBarChart(barLabels, barSegments, headerLabels);
    if (barLabels.length > 0) {
      this.ratingResponseBarChartLoading = false;
      this.isRatingResponseBarChartError = false;
    } else {
      this.ratingResponseBarChartLoading = false;
      this.isRatingResponseBarChartError = true;
    }
  }

  /**
   * Caches segment counts and builds Absolute/Percentage bar config for rating Trend.
   * Line chart data remains for CSV download; Overview is untouched.
   */
  private cacheAndApplyRatingTrendBarChart(
    labels: string[],
    segments: TrendBarSegmentCounts[],
    headerLabels: any
  ): void {
    this.ratingTrendBarSegmentsCache = {
      labels: labels || [],
      segments: segments || [],
      headerLabels: headerLabels || {},
    };
    this.applyRatingTrendBarChartFromCache();
  }

  private applyRatingTrendBarChartFromCache(): void {
    const cache = this.ratingTrendBarSegmentsCache;
    if (!cache?.labels?.length || !cache?.segments?.length) {
      this.ratingTrendBarChart = {};
      return;
    }
    const built = buildQuestionTrendBarChartConfig({
      labels: cache.labels,
      segments: cache.segments,
      headerLabels: cache.headerLabels,
      isPercentage: this.isQuestionTrendChartTypePercentage,
      xText: this.barChartDisplay || '',
      yText: 'Responses',
    });
    this.ratingTrendBarChart = {
      ...built,
      responses: (built.responses || []).map((count) =>
        this.responseAnalyticsService.formatNumber(count)
      ),
    };
  }

  private cacheAndApplySingleSelectBarChart(obj: any): void {
    const datasets: StackedSeriesDataset[] = (obj?.dataset || []).map((item: any) => ({
      label: String(item?.value ?? ''),
      data: (item?.data || []).map((v: any) => Number(v) || 0),
      backgroundColor: item?.backgroundColor,
      maxBarThickness: item?.maxBarThickness ?? 60,
    }));
    this.singleSelectBarCache = {
      labels: obj?.labels || [],
      datasets,
      safeHtmlLabels: (obj?.dataset || []).map((item: any) => item?.label),
      values: (obj?.dataset || []).map((item: any) => item?.value),
      xText: obj?.xText || '',
    };
    this.applySingleSelectBarChartFromCache();
  }

  private applySingleSelectBarChartFromCache(): void {
    const cache = this.singleSelectBarCache;
    if (!cache?.labels?.length || !cache?.datasets?.length) {
      this.barChartSingleSelect = {};
      return;
    }
    const built = buildStackedSeriesBarChartConfig({
      labels: cache.labels,
      datasets: cache.datasets,
      isPercentage: this.isQuestionTrendChartTypePercentage,
      xText: cache.xText || this.lineChartTrendEvents?.display || '',
    });
    this.barChartSingleSelect = {
      labels: built.labels,
      xText: built.xText,
      showPercentage: built.showPercentage,
      responses: (built.responses || []).map((count) =>
        this.responseAnalyticsService.formatNumber(count)
      ),
      dataset: built.dataset.map((item, index) => ({
        ...item,
        label: cache.safeHtmlLabels[index] ?? item.label,
        value: cache.values[index],
        maxBarThickness: 60,
      })),
    };
  }

  private cacheAndApplyMultiSelectLineChart(obj: any): void {
    this.multiSelectLineCache = {
      labels: obj?.labels || [],
      xText: obj?.xText || '',
      series: (obj?.data || []).map((item: any) => ({
        label: item?.label,
        backgroundColor: item?.backgroundColor,
        borderColor: item?.borderColor,
        value: item?.value,
        field_id: item?.field_id,
        is_deleted: item?.is_deleted,
        data: (item?.data || []).map((v: any) => Number(v) || 0),
      })),
    };
    this.applyMultiSelectLineChartFromCache();
  }

  private applyMultiSelectLineChartFromCache(): void {
    const cache = this.multiSelectLineCache;
    if (!cache?.labels?.length || !cache?.series?.length) {
      this.lineChartMultiSelect = {};
      return;
    }
    const isPercentage = this.isQuestionTrendChartTypePercentage;
    const series = cache.series.map((item: any) => ({
      ...item,
      data: [...(item.data || [])],
    }));
    const responses = cache.labels.map((_: string, index: number) => {
      const total = series.reduce((sum: number, item: any) => sum + (Number(item.data[index]) || 0), 0);
      return this.responseAnalyticsService.formatNumber(total);
    });
    if (isPercentage) {
      const pointCount = cache.labels.length;
      for (let i = 0; i < pointCount; i++) {
        const total = series.reduce((sum: number, item: any) => sum + (Number(item.data[i]) || 0), 0);
        series.forEach((item: any) => {
          const value = Number(item.data[i]) || 0;
          item.data[i] = total > 0 ? Number(((value / total) * 100).toFixed(1)) : 0;
        });
      }
    }
    this.lineChartMultiSelect = {
      labels: cache.labels,
      xText: cache.xText || this.lineChartTrendEvents?.display || '',
      yText: isPercentage ? '% Responses' : 'Responses',
      showPercentage: isPercentage,
      responses,
      data: series,
    };
  }

  private prepareBarChartForSingleSelect(primaryQuestion, data): void {
    this.selectionBasedTypeChart = 'singleSelect';
    let obj: any = {
      labels: [],
      xText: this.lineChartTrendEvents?.display,
      dataset: []
    };
    const props = primaryQuestion?.prop;
    for(let key in props) {
      const prop = props[key];
      obj.dataset.push({
        label: this.sanitizer.bypassSecurityTrustHtml(`<span style="display:inline-block; width:10px; height:10px; background-color: ${prop['active_color']}; margin-right:5px; border-radius:2px;"></span>${prop['label']}`),
        data: [],
        backgroundColor: prop['active_color'],
        maxBarThickness: 60,
        value: prop['value']
      })
    }
    data.forEach(item => {
      let datas = item?.detailed_rating.find(fieldId => fieldId.field_id == this.viewDropdownFieldId)?.detailed_rating || item?.detailed_rating.find(fieldId => fieldId.field_id == this.viewDropdownFieldId)?.detailed_rating_details;
      if(datas) {
        obj.labels.push(this.prepareLabelsForChart(item?.time, this.lineChartTrendEvents?.trend_type));
        obj.dataset.forEach(res => {
          const result = datas.find(items => items.rating == res.value)?.number_of_user_rated || 0;
          res.data.push(result)
        })       
      }
    })
    this.cacheAndApplySingleSelectBarChart(obj);
    if(obj.labels.length > 0) {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = false;
    } else {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = true;
    }
  }

  private prepareBarChartForMultiSelect(primaryQuestion, data): void {
    this.selectionBasedTypeChart = 'multiSelect';
    let obj: any = {
      labels: [],
      xText: this.lineChartTrendEvents?.display,
      yText: 'Responses',
      data: []
    };
    const props = primaryQuestion?.prop || {};
    const colorByValue: Record<string, string> = {};
    for (const key in props) {
      colorByValue[props[key]['value']] = props[key]['active_color'];
    }
    const groupMembers = Helpers.brandDetails.detailed_feedback_items.filter(
      (item: any) => item?.group_id == this.viewDropdownFieldId && item?.field_id
    );
    const chartOptions = groupMembers.length > 0
      ? _.orderBy(groupMembers, [(item: any) => !!item?.is_deleted], ['asc']).map((item: any) => {
          const firstProp = item?.prop && Object.keys(item.prop).length ? (Object.values(item.prop)[0] as any) : null;
          return {
            label: item?.label ?? firstProp?.label ?? item?.value,
            value: item?.value,
            field_id: item?.field_id,
            is_deleted: !!item?.is_deleted
          };
        })
      : Object.keys(props).map(key => ({
          label: props[key]['label'],
          value: props[key]['value'],
          field_id: null,
          is_deleted: false
        }));
    chartOptions.forEach(option => {
      const color = colorByValue[option.value] || props[Object.keys(props)[0]]?.['active_color'];
      const deletedMark = option.is_deleted ? '<span style="color:#e53935">*</span>' : '';
      obj.data.push({
        label: this.sanitizer.bypassSecurityTrustHtml(`<span style="display:inline-block; width:10px; height:10px; background-color: ${color}; margin-right:5px; border-radius:2px;"></span>${option.label}${deletedMark}`),
        data: [],
        backgroundColor: color,
        borderColor: color,
        value: option.value,
        field_id: option.field_id,
        is_deleted: option.is_deleted
      });
    });
    data.forEach(item => {
      const parentRating = item?.detailed_rating?.find((dr: any) => dr.field_id == this.viewDropdownFieldId);
      if (!parentRating) {
        return;
      }
      obj.labels.push(this.prepareLabelsForChart(item?.time, this.lineChartTrendEvents?.trend_type));
      obj.data.forEach(datasetItem => {
        const ratingEntry = datasetItem.field_id
          ? item?.detailed_rating?.find((dr: any) => dr.field_id == datasetItem.field_id)
          : parentRating;
        const details = ratingEntry?.detailed_rating_details;
        const count = details?.find((r: any) => r.rating == datasetItem.value)?.number_of_user_rated || 0;
        datasetItem.data.push(count);
      });
    });
    obj.data = obj.data.filter((datasetItem: any) => {
      const total = (datasetItem.data || []).reduce((sum: number, val: number) => sum + (val || 0), 0);
      return !(datasetItem.is_deleted && total === 0);
    });
    this.cacheAndApplyMultiSelectLineChart(obj);
    if(obj.labels.length > 0) {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = false;
    } else {
      this.ratingLineChartCardLoading = false;
      this.isratingLineChartCardError = true;
    }
  }

  private callGetScoreAccount(): void {
    let payload: any = {
      manager_type: 2,
      brand_id: _.get(Helpers, 'brandDetails._id', null),
      main_rater_type: _.get(Helpers, 'brandDetails.main_rater_type', 2),
      shop_id_list: [],
      from: _.get(Helpers, 'datePicker.startDate', null),
      to: _.get(Helpers, 'datePicker.endDate', null),
      universal_filter: _.get(Helpers, 'universalFilter', null),
      category_level: 0,
      is_custom_date_range_selected: _.get(Helpers, 'datePicker.isCustomDateRangeSelected', false),
      field_id: this.viewDropdownFieldId,
      field_id_aggs: false,
      custom_filter_list: _.get(Helpers, 'hierarchyStack', null),
      hierarchy_stack: _.get(Helpers, 'hierarchyStack', null),
      group_alias_key: this.getGroupAliasKey()
    };
    payload = _.omitBy(payload, _.isNil);
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getScoreAccount(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response?.message === 'Success') {
        const datas = response?.data?.aggregations?.range?.buckets;
        let currentBucket: any = null;
        let previousBucket: any = null;
        if (datas) {
          for (const key in datas) {
            if (datas[key]?.key === 'current') {
              currentBucket = datas[key];
            } else if (datas[key]?.key === 'previous') {
              previousBucket = datas[key];
            }
          }
        }
        if (currentBucket) {
          this.lastScoreAccountResponse = { current: currentBucket, previous: previousBucket ?? null };
          this.prepareOverviewDataForRatingType(currentBucket, previousBucket);
        }
      } else {
        this.textCardLoading = false;
        this.isTextCardError = true;
      }
    })
  }

  private callApiForWordCloud(): void {
    let payload: any = {
      "manager_type": 2,
      "brand_id": Helpers?.brandDetails?._id,
      "main_rater_type": Helpers?.brandDetails?.main_rater_type || 2,
      "shop_id_list": [],
      "hierarchy_stack": Helpers?.hierarchyStack,
      "field_id": this.viewDropdownFieldId,
      "from": Helpers?.datePicker?.startDate,
      "to": Helpers?.datePicker?.endDate,
      "cloud_type": 1,
      "is_custom_date_range_selected": Helpers?.datePicker?.isCustomDateRangeSelected,
      "text_v2_status": true,
      "universal_filter": Helpers?.universalFilter || null,
      "group_alias_key": this.getGroupAliasKey()
    };
    if(Helpers?.hierarchyStack) {
      payload['custom_filter_list'] = this.getCustomFilter(Helpers?.hierarchyStack);
    };
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getWordCloud(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response.code == 0 && _.hasIn(response, 'data.aggregations.keywords.buckets') && !_.isEmpty(response.data.aggregations.keywords.buckets)) {
        let words = this.prepareWordCloudData(response.data.aggregations.keywords.buckets);
        if (!_.isEmpty(words)) {
          this.wordCloudCardLoading = false;
          this.isWordCloudCardError = false;
          setTimeout(() => {
            this.createWordCloud(words);
          }, 500);
        } else {
          this.wordCloudCardLoading = false;
          this.isWordCloudCardError = true;
        }
      } else {
        this.wordCloudCardLoading = false;
        this.isWordCloudCardError = true;
      } 
    })
  }

  createWordCloud(words: any): void {
    var maxSize = _.maxBy(words, 'count');
    var minSize = _.minBy(words, 'count');
    const width = 600;
    const height = 250;
    if (maxSize && minSize && maxSize.count == minSize.count) {
      words[0].count = words[0].count + 1;
    }
    const layout = cloud()
      .size([width, height])
      .words(_.map(words, (d: any) => {
      d.text = d.words;
      d.size = this.getFontSize(maxSize.count, minSize.count, d.count)
        return d;
      }))
      .padding(5)
      .rotate(function () { return 0 })
      .fontSize((d: any) => { return d.size; })
      .spiral('archimedean')
      .on("end", this.draw.bind(this));
    layout.start();
  }

  draw(words: any): void {
    const width = 600;
    const height = 250;
    const svg = d3.select("#word-cloud")
      .append("svg")
      .attr("width", width)
      .attr("height", height);
    svg.append("g")
    .attr('transform',"translate(320, 120)")
    .attr("preserveAspectRatio", "xMinYMin meet")
    .classed("svg-content-responsive", true)
    .append("g")
    .selectAll("text")
    .data(words)
    .enter().append("text")
    .style("font-size", function (d: any) { 
      return d.size+ "px"; 
    })
    .style("font-family", "Asap")
    .style("color", "Impact")
    .attr("text-anchor", "middle")
    .style("background", 'black')
    .style('cursor', 'default')
    .style("fill", (d: any, i) => {
      return d.color;
    })
    .attr("transform", function (d: any) {
      return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
    })
    .text(function (d: any) { return d.text; })
  }

  private getFontSize(currMax, currMin, size) {
    let addedValueOnFontSize = 10;
    if(size == currMin && currMin == currMax){
      return  25 + addedValueOnFontSize;
    }else{
      return (((size - currMin) / (currMax - currMin)) * 25) + addedValueOnFontSize;
    }
  }

  private prepareWordCloudData(buckets) {
    let mainRaterType = Helpers?.brandDetails?.main_rater_type;
    var data: any = [];
    _.each(buckets, (bucket) => {
      if (bucket['key'] && bucket['key'].length > 3) {
        var obj = {},
        cloudObj = {};
        _.each(bucket.range.buckets, (bucket) => {
          if (bucket.key == 'current') {
            if (mainRaterType == 3 || mainRaterType == 10) {
              obj['promoter'] = bucket.promoters.doc_count;
              obj['passive'] = bucket.passives.doc_count;
              obj['detractor'] = bucket.detractors.doc_count;
            } else if ([4, 6, 7, 9].indexOf(mainRaterType) != -1) {
              obj['top'] = bucket.top.doc_count;
              obj['mid'] = bucket.mid.doc_count;
              obj['bottom'] = bucket.bottom.doc_count;
            } else {
              obj['positive'] = bucket.positives.doc_count;
              obj['negative'] = bucket.negatives.doc_count;
            }
            obj['count'] = bucket.doc_count;
            obj['color'] = this.getColors(bucket);
          }
        });
        obj['words'] = bucket['key'];
        data.push(obj);
      }
    });
    return data;
  }

  private getColors(bucket) {
    let mainRaterType = Helpers?.brandDetails?.main_rater_type;
    var color = 'grey';
    if (mainRaterType == 3 || mainRaterType == 10) {
      var max = Math.max(bucket.promoters.doc_count, bucket.passives.doc_count, bucket.detractors.doc_count);
      if (max == bucket.promoters.doc_count) {
        color = '#008000';
      } else if (max == bucket.passives.doc_count) {
        color = '#ffa500';
      } else if (max == bucket.detractors.doc_count) {
        color = '#ff0000';
      }
    } else if ([4, 6, 7, 9].indexOf(mainRaterType) != -1) {
      var max = Math.max(bucket.top.doc_count, bucket.mid.doc_count, bucket.bottom.doc_count);
      if (max == bucket.top.doc_count) {
        color = '#10a754';
      } else if (max == bucket.mid.doc_count) {
        color = '#fab416';
      } else if (max == bucket.bottom.doc_count) {
        color = '#ed2424';
      }
    } else {
      var max = Math.max(bucket.positives.doc_count, bucket.negatives.doc_count);
      if (max == bucket.positives.doc_count) {
        color = '#0b7139';
      } else if (max == bucket.negatives.doc_count) {
        color = '#ed2424';
      }
    }
    return color;
  }

  private getGroupAliasKey(): any {
    let hierarchyStack = _.get(Helpers, 'hierarchyStack', []) || [];
    hierarchyStack = hierarchyStack.filter(stack => stack?.field_id != 'touchpoints');
    if(hierarchyStack?.length) {
      const currentLevel = hierarchyStack[hierarchyStack.length - 1]?.field_id;
      if (currentLevel) {
        const hierarchyListAlias = _.get(Helpers, 'brandDetails.hierarchy_list_alias', {});
        const alias = _.find(hierarchyListAlias, (item: any) => item?.values?.includes(currentLevel));
        if (alias) {
          const values = alias?.values;
          const nextLevelIndex = values.indexOf(currentLevel) + 1;
          return values[nextLevelIndex] || null;
        }
      }
    } else {
      const hierarchyFilterMapping =  Helpers?.hierarchyFilterMapping;
      return hierarchyFilterMapping[1]?.key;
    }
  }

  private getHeaderLabels(mainRaterType: string | number, scalerRaterType: string | number, isPrimaryRating: boolean): any {
    if (mainRaterType === undefined && scalerRaterType === undefined) {
        return;
    }
    let npsDisplayName: string = _.get(Helpers, 'brandDetails.label_configs.NPS.value', 'NPS');
    if(!npsDisplayName) {
      npsDisplayName = 'NPS';
    }
    const obj = { top: '', mid: '', bottom: '', rating: 'Rating', display: 'Rating' };
    const mapRaterTypeToLabels = {
      '0-10': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '1-5': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '1-10': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '7': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '5': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '9': { top: 'TB', mid: 'MB', bottom: 'BB' },
      '-5 to 5': { top: 'Positives', mid: '', bottom: 'Negatives' },
      '-5 to +5': { top: 'Positives', mid: '', bottom: 'Negatives' },
      '8': { top: isPrimaryRating ? 'T3B' : 'Positives', mid: isPrimaryRating ? 'MB' : '', bottom: isPrimaryRating ? 'B3B' : 'Negatives' }
    };
    const raterTypeKey = mainRaterType !== undefined ? mainRaterType.toString() : null;
    const scalerTypeKey = scalerRaterType !== undefined ? scalerRaterType.toString() : null;
    const labels = (scalerTypeKey && mapRaterTypeToLabels[scalerTypeKey]) || null;
    return labels ? { ...obj, ...labels } : obj;
  }

  private getRatingBasedData(fieldId: any, data: any, mainRaterType: string | number, scalerRaterType: string | number, isPrimaryRating: boolean, cardType: string): any {
    if (!data && cardType === 'textBased') {
      return {
        totalCount: '0',
        rating: 'N/A',
        totalTop: '0',
        totalMid: '0',
        totalBottom: '0',
        seprateRating: [],
        topPercentage: '0%',
        midPercentage: '0%',
        bottomPercentage: '0%',
        fieldId: this.viewDropdownFieldId
      };
    }
    let prop = _.get(Helpers, 'brandDetails.detailed_feedback_items', []).find(item => item?.field_id == fieldId)?.prop;
    let totalResponse: any = 0;
    let rating: any = 0;
    let totalTop: any = 0;
    let totalMid: any = 0;
    let totalBottom: any = 0;
    let seprateRating: any = [];
    let sumOfPrimaryRating = 0;
    const category = this.responseAnalyticsService.getRatingBandsByRaterType(scalerRaterType);
    if(prop && cardType === 'allQuestion' || cardType == 'ratingBased' || cardType === 'lineChartDownload' || cardType === 'textBased') {
      for(let key in prop) {
        seprateRating.push({...prop[key], count: 0, percentage: '0%'});
      }
    }
    if(cardType === 'allQuestion' || cardType === 'ratingBased' || cardType === 'lineChart' || cardType === 'lineChartDownload') {
      for (let key in data) {
        const rating = data[key].rating || data[key]?.key || 0;
        const numberOfUsersRated = data[key]?.number_of_user_rated || data[key]?.number_of_users_rated || data[key]?.doc_count || 0;
        if (category?.bottom.includes(rating)) {
          totalBottom += numberOfUsersRated;
          sumOfPrimaryRating += numberOfUsersRated * rating;
        } else if (category?.mid && category?.mid.includes(rating)) {
          totalMid += numberOfUsersRated;
          sumOfPrimaryRating += numberOfUsersRated * rating;
        } else if (category?.top.includes(rating)) {
          totalTop += numberOfUsersRated;
          sumOfPrimaryRating += numberOfUsersRated * rating;
        }
      }
    } else if(cardType === 'textBased') {
      totalResponse = data?.doc_count || 0;
      rating = totalResponse > 0 ? data?.avg_rating?.value.toFixed(2) : 'N/A';
      data = data?.primary_rating_details?.buckets;
      if (data) {
        for (let key in data) {
          const rating = data[key].rating || data[key]?.key || 0;
          const numberOfUsersRated = data[key]?.number_of_user_rated || data[key]?.number_of_users_rated || data[key]?.doc_count || 0;
          if (category.bottom.includes(rating)) {
            totalBottom += numberOfUsersRated;
            sumOfPrimaryRating += numberOfUsersRated * rating;
          } else if (category?.mid && category?.mid.includes(rating)) {
            totalMid += numberOfUsersRated;
            sumOfPrimaryRating += numberOfUsersRated * rating;
          } else if (category.top.includes(rating)) {
            totalTop += numberOfUsersRated;
            sumOfPrimaryRating += numberOfUsersRated * rating;
          }
        }
      }
    }
    if(cardType !== 'textBased') {
      totalResponse = totalTop + totalMid + totalBottom;
      if(scalerRaterType == '0-10' || scalerRaterType == '1-5') {
        rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
        if (rating !== 'N/A') {
          if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
            rating = Math.floor(rating);
          } else if (rating > 0 && rating % 1 === 0.5) {
            rating = Math.ceil(rating);
          } else {
            rating = Math.round(rating);
          }
        }
      } else {
        rating = totalResponse > 0 ? (sumOfPrimaryRating / totalResponse).toFixed(2) : 'N/A';
      }
    } else {
      totalResponse = (totalTop + totalMid + totalBottom) || 0; 
      if(scalerRaterType == '0-10' || scalerRaterType == '1-5') {
        rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
        if (rating !== 'N/A') {
          if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
            rating = Math.floor(rating);
          } else if (rating > 0 && rating % 1 === 0.5) {
            rating = Math.ceil(rating);
          } else {
            rating = Math.round(rating);
          }
        }
      }
    }
    if(cardType === 'textBased') {
      if (Array.isArray(data)) {
        data.forEach(item => {
          let ratingObj = seprateRating.find(items => items.value == item.key);
          if (ratingObj) {
            ratingObj.count = item?.doc_count || 0;
            ratingObj.percentage = totalResponse > 0 ? (((item?.doc_count || 0) / totalResponse) * 100).toFixed(1) + '%' : '0%';
          }
        });
      }
    } else {
      for(let key in data) {
        let ratingObj: any = {};
        if(this.selectedCardName === 'all-questions' || cardType === 'lineChartDownload') {
          ratingObj = seprateRating.find(item => item.value == data[key].rating);
        } else if(this.selectedCardName === 'rating') {
          ratingObj = seprateRating.find(item => item.value == key);
        }
        if (ratingObj) {
          ratingObj.count = data[key]?.number_of_user_rated ||  data[key]?.number_of_users_rated || data[key]?.doc_count || 0;
          ratingObj.percentage = totalResponse > 0 ? (((data[key]?.number_of_user_rated ||  data[key]?.number_of_users_rated || data[key]?.doc_count || 0) / totalResponse) * 100).toFixed(1) + '%' : '0%';
        }
      }
    }
    let topPercentage = totalResponse > 0 ? ((totalTop/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalTop/totalResponse)*100) + '%' : ((totalTop/totalResponse)*100).toFixed(1) + '%' : '0%';
    let midPercentage = totalResponse > 0 ? ((totalMid/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalMid/totalResponse)*100) + '%' : ((totalMid/totalResponse)*100).toFixed(1) + '%' : '0%';
    let bottomPercentage = totalResponse > 0 ? ((totalBottom/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalBottom/totalResponse)*100) + '%' : ((totalBottom/totalResponse)*100).toFixed(1) + '%' : '0%';
    let raterType: any = mainRaterType || scalerRaterType;

    // Retrieve the question object based on fieldId
    const question = this.questionMap[fieldId];
    // Check if the question is of a specific component type and if extended rater type is 4
    if (question && question.component_type === 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4) {
      // Proceed only if extended_rating_mapper exists and is not empty
      if (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper)) {
        // Get the updated distribution using dynamic mapping logic
        seprateRating = this.extenderRatingMapper.getDynamicMappingExtendedRatingData(seprateRating, question);
      }
    }

    return {
      totalCount: this.responseAnalyticsService.formatNumber(totalResponse || 0),
      rating: rating,
      totalTop: this.responseAnalyticsService.formatNumber(totalTop || 0),
      totalMid: raterType == '-5 to 5' || raterType == '-5 to +5' || raterType == '1' || (raterType == '8' && !isPrimaryRating) ? '' : this.responseAnalyticsService.formatNumber(totalMid || 0),
      totalBottom: this.responseAnalyticsService.formatNumber(totalBottom || 0),
      seprateRating: seprateRating,
      topPercentage: topPercentage,
      midPercentage: midPercentage,
      bottomPercentage: bottomPercentage,
      fieldId: this.viewDropdownFieldId
    };
  }

  private getSelectionBasedData(fieldId: any, data: any): any {
    const rowData: any = {
      totalCount: 0,
      options: []
    };
    if (!data) {
      return rowData;
    }
    const detailedFeedbackItems: any = Helpers?.brandDetails?.detailed_feedback_items.filter(item => item?.field_id == fieldId)[0];
    const props = detailedFeedbackItems?.prop;
    const isMultiWithGroup = !detailedFeedbackItems?.type?.includes('single');
    const groupMembers = isMultiWithGroup
      ? Helpers.brandDetails.detailed_feedback_items.filter((item: any) => item?.group_id == fieldId)
      : [];
    if (isMultiWithGroup && groupMembers.length > 0) {
      // One row per group member (each detailed_feedback_item); is_deleted at bottom
      const sorted = _.orderBy(groupMembers, [(item: any) => !!item?.is_deleted], ['asc']);
      sorted.forEach((item: any) => {
        const firstProp = item?.prop && Object.keys(item.prop).length ? (Object.values(item.prop)[0] as any) : null;
        const label = item?.label ?? firstProp?.label ?? item?.value;
        rowData.options.push({
          value: item?.value,
          label: label,
          field_id: item?.field_id,
          response: 0,
          is_deleted: !!item?.is_deleted
        });
      });
    } else {
      for (let key in props || {}) {
        const prop = props[key];
        rowData.options.push({ value: prop['value'], label: prop['label'], response: 0 });
      }
    }
    if (this.selectedCardName == 'all-questions') {
      rowData.totalCount = this.responseAnalyticsService.formatNumber(data.find((items: any) => items.field_id === fieldId)?.number_of_user_rated || 0);
      if (isMultiWithGroup && groupMembers.length > 0) {
        // Each option gets response only from its own field_id (no sum across group)
        rowData.options.forEach((option: any) => {
          const result = data.find((item: any) => item.field_id == option.field_id)?.detailed_rating_details;
          const response = (result && _.isArray(result))
            ? (result.find((r: any) => r.rating == option.value)?.number_of_user_rated || 0)
            : 0;
          option.response = this.responseAnalyticsService.formatNumber(response);
        });
      } else if (isMultiWithGroup) {
        const result = data.find((items: any) => items.field_id === fieldId)?.detailed_rating_details;
        rowData.options.forEach((option: any) => {
          const count = result?.find((r: any) => r.rating == option.value)?.number_of_user_rated || 0;
          option.response = this.responseAnalyticsService.formatNumber(count);
        });
      } else {
        const result = data.find((items: any) => items.field_id === fieldId)?.detailed_rating_details;
        if (_.size(result) > 0) {
          rowData.options.forEach((option: any) => {
            const count = result.find((r: any) => r.rating == option.value)?.number_of_user_rated || 0;
            option.response = this.responseAnalyticsService.formatNumber(count);
          });
        }
      }
    } else {
      rowData.totalCount = this.responseAnalyticsService.formatNumber(data[this.viewDropdownFieldId]?.doc_count || 0);
      if (isMultiWithGroup && groupMembers.length > 0) {
        // Each option gets response only from its own field_id (no sum across group)
        rowData.options.forEach((option: any) => {
          let count = 0;
          const obj = data[option.field_id]?.rating_number;
          if (obj && typeof obj === 'object') {
            for (const keys of Object.keys(obj)) {
              if (obj[keys]?.key == option.value) {
                count += obj[keys]?.doc_count || 0;
              }
            }
          }
          option.response = this.responseAnalyticsService.formatNumber(count);
        });
      } else if (isMultiWithGroup) {
        const obj = data[this.viewDropdownFieldId]?.rating_number;
        rowData.options.forEach((option: any) => {
          let count = 0;
          for (const keys in obj || {}) {
            if (obj[keys]?.key == option.value) {
              count += obj[keys]?.doc_count || 0;
            }
          }
          option.response = this.responseAnalyticsService.formatNumber(count);
        });
      } else {
        const obj = data[this.viewDropdownFieldId]?.rating_number;
        rowData.options.forEach((option: any) => {
          let count = 0;
          for (const keys in obj || {}) {
            if (obj[keys]?.key == option.value) {
              count += obj[keys]?.doc_count || 0;
            }
          }
          option.response = this.responseAnalyticsService.formatNumber(count);
        });
      }
    }
    // Hide rows that are deleted and have zero response
    rowData.options = rowData.options.filter((opt: any) =>
      !(opt.is_deleted && (opt.response === 0 || opt.response === '0'))
    );
    return rowData;
  }

  /** One row per option; percent of response count only (e.g. `0%`, `50%`). single-select & multi-select. */
  private buildSelectionDistributionRows(rowData: any): { text: string }[] {
    if (!rowData?.options?.length) {
      return [];
    }
    const total = parseInt(String(rowData?.totalCount ?? 0).replace(/,/g, ''), 10) || 0;
    const fmt = (pct: number) =>
      pct.toFixed(1).endsWith('.0') ? String(Math.floor(pct)) : pct.toFixed(1);
    return rowData.options.map((opt: any) => {
      const count = parseInt(String(opt?.response ?? 0).replace(/,/g, ''), 10) || 0;
      if (total <= 0) {
        return { text: '0%' };
      }
      const pct = (count / total) * 100;
      return { text: `${fmt(pct)}%` };
    });
  }

  private prepareLabelsForChart(date: any, trendType: any): any {
    if(trendType == 0) {
      return moment.utc(date).format('hh:mm A');
    } else if(trendType == 1 || trendType == 2) {
      return moment.utc(date).format("DD MMM 'YY");
    } else if(trendType == 3) {
      return moment.utc(date).format("MMM 'YY");
    } else if(trendType == 4) {
      return moment.utc(date).format('MMM')+"-"+moment.utc(date).endOf('quarter').format('MMM')+" "+ moment.utc(date).format('YYYY');
    } else if(trendType == 5) {
      return moment.utc(date).format("YYYY");
    }
  }

  private getCustomFilter(hierarchyStack: any): any {
    let array: any = [];
    for(let key in hierarchyStack) {
      array.push({field: hierarchyStack[key]?.field_id, value: hierarchyStack[key]?.group_key[0]});
    }
    return array;
  }

  private getSelectedTrendQuestion(): any {
    return Helpers.brandDetails.detailed_feedback_items.find(item => item.field_id == this.viewDropdownFieldId)
      || Helpers.brandDetails.detailed_feedback_items.find(item =>
        item.dynamic_properties?.question_group?.some(group => group.id === this.viewDropdownFieldId)
      );
  }

  private getLineChartItemRatingDetails(item: any): any {
    return item?.detailed_rating?.find(field => field.field_id == this.viewDropdownFieldId)?.detailed_rating
      || item?.detailed_rating?.find(field => field.field_id == this.viewDropdownFieldId)?.detailed_rating_details;
  }

  private getGroupedLineChartRatingDetails(item: any): any[] {
    const groupQuestions = _.filter(Helpers.brandDetails.detailed_feedback_items, obj =>
      obj.type === 'rating' &&
      obj.dynamic_properties && _.some(obj.dynamic_properties.question_group, { id: this.viewDropdownFieldId })
    );
    const aggregated: Record<number, number> = {};
    groupQuestions.forEach(question => {
      const fieldRating = item?.detailed_rating?.find(dr => dr.field_id === question.field_id);
      const result = fieldRating?.detailed_rating || fieldRating?.detailed_rating_details;
      if (!result) {
        return;
      }
      const ratingEntries = Array.isArray(result) ? result : Object.values(result);
      ratingEntries.forEach(detail => {
        const rating = Number(detail?.rating ?? detail?.key);
        const count = detail?.number_of_user_rated || detail?.number_of_users_rated || detail?.doc_count || 0;
        if (!isNaN(rating)) {
          aggregated[rating] = (aggregated[rating] || 0) + count;
        }
      });
    });
    return Object.entries(aggregated).map(([rating, count]) => ({
      rating: Number(rating),
      number_of_user_rated: count
    }));
  }

  private captureTrendEvent(event: any): any {
    return {
      name: event?.name,
      display: event?.display,
      trend_type: event?.trend_type,
    };
  }

  private rememberLineChartCsvState(chart: { labels: any[]; data: any[]; yText: string }): void {
    this.lineChartCsvTrendEvent = this.captureTrendEvent(this.lineChartTrendEvents);
    this.lineChartCsvChart = {
      labels: [...(chart?.labels || [])],
      data: [...(chart?.data || [])],
      yText: chart?.yText || '',
    };
  }

  private prepareTableInfoToCSV(trendEvent?: any): any {
    const event = trendEvent || this.lineChartTrendEvents;
    let interaction = this.getSelectedTrendQuestion()?.question;
    let obj = {
      'Report name :': `Score Trend ${event?.name} Report`,
      'Report Date :': `${moment(Helpers?.datePicker?.formatedStartDate, "DD MMM' YY").format('DD-MMM-YYYY')} - ${moment(Helpers?.datePicker?.formatedEndDate, "DD MMM' YY").format('DD-MMM-YYYY')}`,
      'For Account :': Helpers?.accountDetails?.display_name || Helpers?.accountDetails?.name,
      'For Project :': Helpers?.brandDetails?.display_name || Helpers?.brandDetails?.name,
      'Interaction :': interaction,
      'Downloaded On :': moment().format('DD-MMM-YYYY hh:mm:ss a'),
      'Downloaded By :': Helpers?.managerDetails?.manager?.email_address
    };
    const rows = Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string' && (value.includes(',') || value.includes('\n') || value.includes('"'))) {
        value = `"${value.replace(/"/g, '""')}"`;
      }
      return `${key},${value}`;
    });
    const csv = rows.join('\n');
    return csv;
  }

  prepareChartDataIntoCSVForPrimaryQuestion(chartSource?: { cacheData: any; labels: any[]; data: any[]; yText: string }): any {
    const cacheData = chartSource?.cacheData ?? this.lineChartCacheData;
    const chartLabels = chartSource?.labels ?? this.lineChart.labels;
    const chartValues = chartSource?.data ?? this.lineChart.data;
    const yText = chartSource?.yText ?? this.lineChart.yText;
    const selectedQuestion = this.getSelectedTrendQuestion();
    const isPrimaryRating = !!selectedQuestion?.is_primary_rating;
    const isGroupRating = this.active && selectedQuestion?.type === 'rating';
    const headerLabels = this.getHeaderLabels(selectedQuestion?.main_rater_type, selectedQuestion?.scale_rater_type, selectedQuestion?.is_primary_rating);
    // Check if the question is of a specific component type and if extended rater type is 4
    const rawHeaders = ['Date', yText, 'Responses', headerLabels?.top, headerLabels?.mid, headerLabels?.bottom].filter(Boolean);
    if (selectedQuestion?.is_primary_rating && selectedQuestion?.component_type == 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
      // Get the updated distribution using dynamic mapping logic
      let originalProps = selectedQuestion?.prop;
      let mappedProps: any = [];
      let options: any = [];
      for(let prop in originalProps) {
        // Maps the rating value and updates its label/text based on the extended rater type.
        options.push(this.extenderRatingMapper.getNewOptionsForExtendedRaterType(originalProps[prop], selectedQuestion?.main_rater_type));
      }
      // Removes duplicate options based on the 'value' property from the input array.
      mappedProps = _.sortBy(this.extenderRatingMapper.removeDuplicateOptionsOfExtendedRater(options), 'value');
      // Extract only labels from mappedProps and push to rawHeaders
      mappedProps.forEach(item => {
        rawHeaders.push(item.label);
      });
    }else {
      for(let key in selectedQuestion?.prop) {
        let label = `${selectedQuestion?.prop[key]?.label || ''} (${selectedQuestion?.prop[key]?.value != null ? selectedQuestion?.prop[key]?.value : ''})`;
        rawHeaders.push(label)
      }
    }
    // Save original headers before % columns
    const headers = [...rawHeaders];
    // Add corresponding percentage headers
    const percentHeaders = rawHeaders.slice(3).map(label => `${label} %`);
    headers.push(...percentHeaders);
    const rowData: any = [];
    let filteredLineChartData = cacheData.filter(item => {
      if (isGroupRating) {
        return this.getGroupedLineChartRatingDetails(item).length > 0;
      }
      if (isPrimaryRating) {
        return item?.number_of_users_rated_primary_rating != 0;
      }
      return !!this.getLineChartItemRatingDetails(item);
    });
    filteredLineChartData.forEach(item => {
      const ratingDetails = isGroupRating
        ? this.getGroupedLineChartRatingDetails(item)
        : (isPrimaryRating
          ? item?.primary_rating_details
          : this.getLineChartItemRatingDetails(item));
      let datas = this.getRatingBasedData(
        isGroupRating ? selectedQuestion?.field_id : (isPrimaryRating ? 'primary_rating' : this.viewDropdownFieldId),
        ratingDetails,
        selectedQuestion?.main_rater_type,
        selectedQuestion?.scale_rater_type,
        isPrimaryRating,
        'lineChartDownload'
      );
      let dataArray: any = [];
      dataArray.push(datas?.totalCount);
      dataArray.push(datas?.totalTop == 0 ? 0 : datas?.totalTop);
      if(headerLabels?.mid) {
        dataArray.push(datas?.totalMid == 0 ? 0 : datas?.totalMid);
      }
      dataArray.push(datas?.totalBottom == 0 ? 0 : datas?.totalBottom);
      datas.seprateRating.forEach(data => {
        dataArray.push(data.count == 0 ? 0 : data.count);
      });
      // Compute percentages for all values after "Responses"
      const totalResponses = this.parseCsvNumber(datas?.totalCount) || 1;
      const percentageArray = dataArray.slice(1).map(val => {
        const numericVal = this.parseCsvNumber(val);
        if (isNaN(numericVal)) {
          return '0.00%';
        }
        const percent = ((numericVal / totalResponses) * 100).toFixed(1);
        return `${percent}%`;
      });
      rowData.push([...dataArray, ...percentageArray]);
    });
    const totalRowData = new Array(headers.length).fill(0);
    totalRowData[0] = 'Total';
    totalRowData[1] = '';
    // Sum numeric columns from rowData
    rowData.forEach(row => {
      row.forEach((val, idx) => {
        if (idx < rawHeaders.length - 3 + 1) {
          const numericVal = this.parseCsvNumber(val);
          if (!isNaN(numericVal)) {
            totalRowData[idx + 2] = (totalRowData[idx + 2] || 0) + numericVal;
          }
        }
      });
    });
    const totalResponses = totalRowData[2] || 1;
    // sum only numeric values starting from index 3 to rawHeaders.length-1 (counts columns)
    const countsLength = rawHeaders.length - 3; 
    // totalRowData starts from index 2 as Responses, then counts
    for(let i = 0; i < countsLength; i++) {
      if (typeof totalRowData[i+3] === 'number') {
        // OK
      } else {
        totalRowData[i+3] = 0;
      }
    }
    // Compute totalRowData[1] based on selected question scale
    const scalerRaterType = selectedQuestion?.scale_rater_type;
    let ratingResult = 0;
    if (scalerRaterType == '0-10' || scalerRaterType == '1-5') {
      const topIndex = rawHeaders.indexOf(headerLabels?.top);
      const bottomIndex = rawHeaders.indexOf(headerLabels?.bottom);
      const topCount = totalRowData[topIndex] || 0;
      const bottomCount = totalRowData[bottomIndex] || 0;
      ratingResult = ((topCount - bottomCount) / totalResponses) * 100;
      totalRowData[1] = `${ratingResult.toFixed()}`;
    } else {
      let weightedSum = 0;
      filteredLineChartData.forEach((item, index) => {
        const rowRating = this.parseCsvNumber(chartValues[index]);
        const rowResponse = this.parseCsvNumber(rowData[index][0]);
        if (!isNaN(rowRating) && !isNaN(rowResponse)) {
          weightedSum += (rowRating * rowResponse);
        }
      });
      ratingResult = weightedSum / totalResponses;
      totalRowData[1] = ratingResult.toFixed(2);
    }
    // Compose percentage columns for total row
    const totalPercentages: any = [];
    for(let i = 3; i < rawHeaders.length; i++) {
      const val = totalRowData[i];
      if (typeof val === 'number' && totalResponses > 0) {
        totalPercentages.push(`${((val / totalResponses) * 100).toFixed(2)}%`);
      } else {
        totalPercentages.push('0.00%');
      }
    }
    const totalRow = [
      totalRowData[0],
      totalRowData[1],
      totalRowData[2],
      ...totalRowData.slice(3, rawHeaders.length),
      ...totalPercentages
    ];
    // Compose CSV rows
    const rows = (chartLabels || []).map((label, index) => {
      const row = [label, chartValues?.[index], ...(rowData[index] || [])];
      return row.map(val => this.escapeCsvValue(val)).join(',');
    });
    // Append total row
    rows.push(totalRow.map(val => this.escapeCsvValue(val)).join(','));
    const csvContent = [headers.map(h => this.escapeCsvValue(h)).join(','), ...rows].join('\n');
    return csvContent;
  }

  private escapeCsvValue(value: any): string {
    if (value == null) {
      return '';
    }
    const stringValue = String(value);
    if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  }

  private parseCsvNumber(value: any): number {
    if (typeof value === 'number') {
      return value;
    }
    if (value == null || value === '') {
      return NaN;
    }
    return parseFloat(String(value).replace(/,/g, ''));
  }

  prepareChartDataIntoCSVForMultiSelect(chartData): any {
    // Step 1: Extract and clean labels from series
    let absoluteLabels: string[] = [];
    const dataArray = chartData.dataset ?? chartData.data;
    dataArray.forEach(item => {
      const match = item.label.changingThisBreaksApplicationSecurity.match(/<\/span>(.*)/);
      const result = match ? match[1].replace(/<[^>]*>/g, '').trim() : null;
      if (result) {
        absoluteLabels.push(this.escapeCsvValue(result));
      }
    });
    // Step 2: Prepare headers
    const percentageLabels = absoluteLabels.map(label => label + '%');
    const header = ['Date', 'Response', ...absoluteLabels, ...percentageLabels];
    const transposedCSV: string[] = [header.join(',')];
    // Prepare accumulators for totals
    let responseTotal = 0;
    const seriesTotals = new Array(absoluteLabels.length).fill(0);
    // Step 3: Build rows
    chartData.labels.forEach((label, i) => {
      const dataRow = dataArray.map(d => d.data[i]);
      const total = dataRow.reduce((sum, val) => sum + val, 0);
      // Accumulate totals
      responseTotal += total;
      dataRow.forEach((val, idx) => {
        seriesTotals[idx] += val;
      });
      const percentages = dataRow.map(val =>
        total > 0 ? `${((val / total) * 100).toFixed(2)}%` : '0.00%'
      );
      const row = [label, total, ...dataRow, ...percentages];
      transposedCSV.push(row.join(','));
    });
    // Step 4: Prepare the total row
    // Calculate series total percentages relative to responseTotal
    const totalPercentages = seriesTotals.map(val =>
      responseTotal > 0 ? `${((val / responseTotal) * 100).toFixed(2)}%` : '0.00%'
    );
    const totalRow = [
      'Total',
      responseTotal,
      ...seriesTotals,
      ...totalPercentages
    ];
    transposedCSV.push(totalRow.join(','));
    // Step 5: Final CSV string
    const finalCSV = transposedCSV.join('\n');
    return finalCSV;
  }

  sendReportForDownload(processedFile: any, trendEvent?: any): void {
    const event = trendEvent || this.lineChartTrendEvents;
    var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(processedFile);
    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: `Score Trend ${event?.name} Report - ${moment().format('DD-MMM-YYYY')}`,
      orignal_filename: `Score Trend ${event?.name} Report - ${moment().format('DD-MMM-YYYY')}` + ".csv",
      fileType: 'csv',
      dataSource: 'dashboard',
      progress: 100,
      uri: uri
    };
    this.downloadService.updateList(downloadData);
    this.downloadService.showDownloadSideBar(true);
  }

  private applyComparisonApiDateRange(payload: any): void {
    if (!payload) {
      return;
    }
    applyComparisonApiDateRange(
      payload,
      _.get(Helpers, 'datePicker', null) ?? Helpers?.datePicker
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}